<template>
	<div class="w100">
		<!--bgYear 横批-->
		<!-- <div class="year-header w100 textCenter" id="dl-top" v-if="showTitle">
            <img src="../../assets/images/ej/dl-top-txt3.png" alt="">
			<img src="../../assets/images/ej/dl-top-close.png" class="dl-top-close" @click="showTitle = false"/>
        </div> -->
		<!-- <Header></Header> -->
		<!--style="margin-top: 110px;"-->
		<div class="">
			<!-- class="bgYear"-->
			<!-- <div style="padding-top: 116px;"></div> -->
			<Header></Header>
			<!--style="margin-top: 110px;"-->

			<article class="wContent center" style="padding-bottom: 20px;">
				<!-- 左边悬浮 -->
				<a class="download-entry-left" v-show="showFloatAd" style="position: fixed;top: 100px;z-index: 999;"
					href="https://vote.chinatsi.net/datamarket/" target="_blank">
					<img src="../../assets/images/zhitongche.png" style="width: 140px;" alt="" srcset="">
				</a>
				<a class="download-entry-left" v-show="showFloatAd" style="position: fixed;top: 440px;z-index: 999;cursor: default;"
					href="javascript:;">
					<img src="../../assets/images/price/app.png" style="width: 140px;" alt="" srcset="">
				</a>

				<!-- 右边悬浮 -->
				<a class="download-entry" v-show="showFloatAd" style="position: fixed;top: 100px;z-index: 999;"
					href="javascript:;" @click="goDownLoadPage">
					<img src="../../assets/images/data_download.gif" style="width: 140px;" alt="" srcset="">
				</a>
				<a class="download-entry" v-show="showFloatAd" style="position: fixed;top: 440px;z-index: 999;cursor: default;"
					href="javascript:;">
					<img src="../../assets/images/price/app.png" style="width: 140px;" alt="" srcset="">
				</a>
				
				
				<!-- 下拉效果广告 -->
				<div class="ad-slide-box" id="adSlideBox"><img @click="ADSlideToggle()"
						src="../../assets/images/index_slide_little.png" alt="" style="width: 60px; height: 60px;">
				</div>
				<div style="height: 0px; overflow: hidden;" id="slideAD">
					<router-link to="/heitiane" target="_blank">
						<img src="../../assets/images/index_slide_main3.jpg" alt="" id="adSlideImg" style="display:block;">
                    </router-link>
					<a href="javascript:;" target="_blank">
						<img src="../../assets/images/index_slide_main3.jpg" alt="" id="adSlideImg"
							style="display:block;">
					</a>
				</div>

				<div v-if="adIDsIndex[6]['list']">
					<a v-for="(item, index) in adIDsIndex[6]['list']" :key="index" :href="item.adLink" target="_blank"
						class="w100 block">
						<img :src="item.adPicturePath" alt="" class="w100">
					</a>
				</div>
				
				<div style="margin-bottom: 20px; display: none;">
					<img height="200" width="1200" src="../../assets/images/bannernew.png"/>
				</div>
				
				<!-- <div v-if="adIDsIndex[6]['list']">
                    <el-carousel height="100px">
                        <el-carousel-item v-for="(item, index) in (adIDsIndex[6] ? adIDsIndex[6]['list'] : [])" :key="index">
                            <a :href="item.adLink" target="_blank" class="w100 block">
                                <img :src="item.adPicturePath" alt="" srcset="">
                            </a>
                        </el-carousel-item>
                    </el-carousel>
                </div>
				<!-- 新增调价 0329 start zhangziao -->
				<div class="bgWhite w100">
					<div v-loading="tjloading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
						element-loading-background="rgba(255, 255, 255, 1)">
						<el-row :gutter="24" style="margin: 0;">
							<el-col :span="2"
								style="height: 40px;line-height: 40px;font-size: 14px;font-weight: 700;color: #ffffff;background-color: #a30000;">
								今日调价：</el-col>
							<el-col :span="21" style="overflow: hidden;">
								<template v-show="tj_list.length > 0">
									<marquee style="height: 40px;line-height: 40px;font-size: 16px;width: 100%;"
										direction="left" scrollamount="3" onmouseover="this.stop()"
										onmouseout="this.start()">
										<a style="margin-right: 5px;white-space:nowrap;"
											v-for="(cItem, cIndex) in tj_list[0].list" :key="cIndex">
											<span style="color: #a30000;">[{{ cItem.time }}]</span><span
												style="margin-right: 20px;">{{ cItem.info }}</span>
										</a>
									</marquee>
								</template>
								<div style="height: 40px;line-height: 40px;font-size: 16px;text-align: center;"
									v-show="tj_list.length == 0">暂无数据~</div>
							</el-col>
						</el-row>
					</div>
				</div>
				<!-- 新增调价 0329 end -->
				<!-- 顶部部分 start -->
				<div class="index-part-1 bgWhite">
					<div class="index-part-1-list inlineBlock" v-for="(item, index) in submenu_list_1" :key="index">
						<span class="inlineBlock font12 fontBold"
							v-if="item.isVaild == 'Y'">{{ item.navigationName.substr(0, 1) }}<br />{{ item.navigationName.substr(1, 1) }}</span>
						<span class="inlineBlock font12" v-if="item.isVaild == 'Y'"
							:style="{'max-width': item.navigationName == '资讯' ? '175px' : (item.navigationName == '研报' ? '180px' : (item.navigationName == '指数' ? '270px' : '295px'))}">
							<span class="block">
								<template v-for="(cItem, cIndex) in item.childs" v-show="cItem.isVaild == 'Y'">
									<a v-if="cItem.navigationUrl && cItem.navigationUrl.indexOf('http') === 0" :href="cItem.navigationUrl" target="_blank" class="inlineBlock fontLight">{{ cItem.navigationName }}</a>
									<router-link v-else target="_blank" :to="cItem.navigationUrl" class="inlineBlock fontLight">{{ cItem.navigationName }}</router-link>
								</template>
							</span>
						</span>
					</div>
					<div class="index-part-1-list inlineBlock"
						style="padding-left: 0; float: right; margin-top: -52px; padding-right: 50px;">
						<div class="swiper-container swiper-container-menu" style="width: 270px; height: 52px;">
							<div class="swiper-wrapper">
								<div class="swiper-slide pointer" @click="goPriceIndex('GP')">
									<p style="line-height: 26px;"><span
											class="fontNormal fontBold font14">唐宋钢坯价格指数</span><small
											class="fontLighter floatRight">{{ priceIndexGP['rq'] }}</small></p>
									<p style="line-height: 26px;">
										<span class="inlineBlock vBot"
											style="width: 130px">{{ priceIndexGP['nodeName'] }}</span>
										<span class="inlineBlock vBot textCenter fontDark font14"
											:class="{'fontRed': priceIndexGP['range'] > 0, 'fontGreen': priceIndexGP['range'] < 0}"
											style="width: 70px">{{ priceIndexGP['data'] ? parseInt(priceIndexGP['data']) : '' }}</span>
										<span class="inlineBlock vBot textRight fontDark font14"
											:class="{'fontRed': priceIndexGP['range'] > 0, 'fontGreen': priceIndexGP['range'] < 0}"
											style="width: 70px">
											{{ parseInt(priceIndexGP['chg']) }}
											<i class="font16" v-if="priceIndexGP['range'] != 0"
												:class="{'fontRed el-icon-top': priceIndexGP['range'] > 0, 'fontGreen el-icon-bottom': priceIndexGP['range'] < 0}"></i>
										</span>

									</p>
								</div>
								<div class="swiper-slide pointer" @click="goPriceIndex('JKK')">
									<p style="line-height: 26px;"><span
											class="fontNormal fontBold font14">唐宋进口矿价格指数</span><small
											class="fontLighter floatRight">{{ priceIndexJKK['rq'] }}</small></p>
									<p style="line-height: 26px;">
										<span class="inlineBlock vBot"
											style="width: 130px">{{ priceIndexJKK['nodeName'] }}</span>
										<span class="inlineBlock vBot textCenter fontDark font14"
											:class="{'fontRed': priceIndexJKK['range'] > 0, 'fontGreen': priceIndexJKK['range'] < 0}"
											style="width: 70px">{{ priceIndexJKK['data'] ? parseInt(priceIndexJKK['data']) : '' }}</span>
										<span class="inlineBlock vBot textRight fontDark font14"
											:class="{'fontRed': priceIndexJKK['range'] > 0, 'fontGreen': priceIndexJKK['range'] < 0}"
											style="width: 70px">
											{{ parseInt(priceIndexJKK['chg']) }}
											<i class="font16" v-if="priceIndexJKK['range'] != 0"
												:class="{'fontRed el-icon-top': priceIndexJKK['range'] > 0, 'fontGreen el-icon-bottom': priceIndexJKK['range'] < 0}"></i>
										</span>
									</p>
								</div>
								<div class="swiper-slide pointer" @click="goPriceIndex('JN')">
									<p style="line-height: 26px;"><span
											class="fontNormal fontBold font14">晋南钢铁价格指数</span><small
											class="fontLighter floatRight">{{ priceIndexJN['dataDate'] }}</small></p>
									<p style="line-height: 26px;">
										<span class="inlineBlock vBot"
											style="width: 130px">{{ priceIndexJN['indexName'] }}</span>
										<span class="inlineBlock vBot textCenter fontDark font14"
											:class="{'fontRed': priceIndexJN['ringNum'] > 0, 'fontGreen': priceIndexJN['ringNum'] < 0}"
											style="width: 70px">{{ priceIndexJN['higthPrice'] ? parseInt(priceIndexJN['higthPrice']) : '' }}</span>
										<span class="inlineBlock vBot textRight fontDark font14"
											:class="{'fontRed': priceIndexJN['ringNum'] > 0, 'fontGreen': priceIndexJN['ringNum'] < 0}"
											style="width: 70px">
											{{ parseInt(priceIndexJN['upDownNum']) }}
											<i class="font16" v-if="priceIndexJN['ringNum'] != 0"
												:class="{'fontRed el-icon-top': priceIndexJN['ringNum'] > 0, 'fontGreen el-icon-bottom': priceIndexJN['ringNum'] < 0}"></i>
										</span>
									</p>
								</div>
								<div class="swiper-slide pointer" @click="goPriceIndex('DG')">
									<p style="line-height: 26px;"><span
											class="fontNormal fontBold font14">唐宋带钢价格指数</span><small
											class="fontLighter floatRight">{{ priceIndexDG['rq'] }}</small></p>
									<p style="line-height: 26px;">
										<span class="inlineBlock vBot"
											style="width: 130px">{{ priceIndexDG['nodeName'] }}</span>
										<span class="inlineBlock vBot textCenter fontDark font14"
											:class="{'fontRed': priceIndexDG['range'] > 0, 'fontGreen': priceIndexDG['range'] < 0}"
											style="width: 70px">{{ priceIndexDG['data'] ? parseInt(priceIndexDG['data']) : '' }}</span>
										<span class="inlineBlock vBot textRight fontDark font14"
											:class="{'fontRed': priceIndexDG['range'] > 0, 'fontGreen': priceIndexDG['range'] < 0}"
											style="width: 70px">
											{{ parseInt(priceIndexDG['chg']) }}
											<i class="font16" v-if="priceIndexDG['range'] != 0"
												:class="{'fontRed el-icon-top': priceIndexDG['range'] > 0, 'fontGreen el-icon-bottom': priceIndexDG['range'] < 0}"></i>
										</span>

									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 顶部部分 end -->

				<!-- 20220915 新增 dialog -->
				<el-dialog title="" :show-close="false" :visible.sync="priceVisiable" width="1300px" center>
					<div style="overflow-y: hidden;">
						<div v-for="i in 3" :key="i"
							style="position: absolute;left: 100px;right: 100px;bottom: 100px;opacity: 0.1;z-index: 1;pointer-events: none;"
							:style="{ top: -300 + i * 300 + 'px' }">
							<img v-for="j in 3" :key="j" style="width: 180px;height: 160px;margin-top: 40px;"
								:style="{ 'margin-left': 130 + 'px' }" src="../../assets/images/price/water.png" />
						</div>

						<div v-if="priceNCodeIndex != 2">
							<span class="price-title">{{ priceNCodeName }}</span>
						</div>
						<div v-if="priceNCodeIndex == 2" class="price-titlelist-parent">
							<span class="price-titlelist" v-for="(item, index) in priceDatas[2]"
								:class="[ `l${index}`, priceNCodeTabIndex == index ? 'active' : '' ]"
								@click="priceTabChange(index)">{{ item.name }}</span>
						</div>

						<div style="display: flex;align-items: flex-start;width: 100%;justify-content: space-between;">
							<div class="price-left">
								<el-date-picker v-model="priceDates" type="daterange" unlink-panels range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
									@input="getDetailPriceData(priceNCodeIndex, priceNCode, priceNCodeName)">
								</el-date-picker>

								<el-table :data="priceNCodeDayDataPage" border style="width: 100%;margin-top: 20px;"
									:header-cell-style="{ background:'#f6f6f6', color:'#000000' }"
									:cell-style="{ padding: 0 }" :row-style="{ height: '36px' }">
									<el-table-column width="160" prop="name" label="品名">
									</el-table-column>
									<el-table-column prop="data" label="价格">
									</el-table-column>
									<el-table-column prop="chg" label="涨跌">
										<template slot-scope="scope">
											<span v-if="scope.row.chg > 0"
												style="color: #D02F19">{{ scope.row.chg }}</span>
											<span v-if="scope.row.chg < 0"
												style="color: #2AD019">{{ scope.row.chg }}</span>
											<span v-if="scope.row.chg == 0"
												style="color: #FEBF21;">{{ scope.row.chg }}</span>
										</template>
									</el-table-column>
									<el-table-column v-if="priceNCodeIndex != 2 && priceNCodeIndex != 5" prop="cz"
										label="材质">
									</el-table-column>
									<el-table-column width="120" v-if="priceNCodeIndex != 2 && priceNCodeIndex != 5"
										prop="gg" label="规格">
									</el-table-column>
									<el-table-column v-if="priceNCodeIndex == 1 || priceNCodeIndex == 4"
										prop="market_country_names" label="地区">
									</el-table-column>
									<el-table-column v-if="priceNCodeIndex == 3" prop="brand_name" label="厂商">
									</el-table-column>
									<el-table-column prop="rq" label="日期">
									</el-table-column>
								</el-table>

								<el-pagination background layout="prev, pager, next" :current-page="priceNCodeCurrent"
									:page-size="priceNCodePageSize" :total="priceNCodeTotal"
									style="margin-top: 20px;margin-left: -10px;" @current-change="priceCurrentChange">
								</el-pagination>
							</div>
							<div class="price-right">
								<div>
									<span class="table-title">月均值</span><span
										v-if="priceNCodeIndex >= 3">（计算节点为上月26日-本月25日）</span>
									<el-table :data="priceNCodeMonthData" border :max-height="350"
										style="width: 100%;margin-top: 20px;"
										:header-cell-style="{ background:'#f6f6f6', color:'#000000' }"
										:cell-style="{ padding: 0 }" :row-style="{ height: '36px' }">
										<el-table-column prop="month_year" label="月份">
										</el-table-column>
										<el-table-column prop="data" label="均值">
										</el-table-column>
										<el-table-column prop="max" label="最高">
										</el-table-column>
										<el-table-column prop="min" label="最低">
										</el-table-column>
										<el-table-column prop="dif" label="差值">
										</el-table-column>
									</el-table>
								</div>
								<div>
									<span class="table-title" style="margin-top: 20px;">年均值</span>
									<el-table :data="priceNCodeYearData" border :max-height="220"
										style="width: 100%;margin-top: 20px;"
										:header-cell-style="{ background:'#f6f6f6', color:'#000000' }"
										:cell-style="{ padding: 0 }" :row-style="{ height: '36px' }">
										<el-table-column prop="sum_year" label="年份">
										</el-table-column>
										<el-table-column prop="data" label="均值">
										</el-table-column>
										<el-table-column prop="max" label="最高">
										</el-table-column>
										<el-table-column prop="min" label="最低">
										</el-table-column>
										<el-table-column prop="dif" label="差值">
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</el-dialog>

				<div>
					<p class="inlineBlock" style="margin-right: 30px;">
						<img style="width: 150px;height: 34px;" src="../../assets/images/price/tswj.png" />
					</p>
				</div>
				<!-- 20220915 新增 钢坯价格，带钢价格 -->
				<div class="prices" v-if="priceDatas && priceDatas.length > 0">
					<div class="item l">
						<div class="title"></div>

						<div class="content">
							<div class="citem" :class="{ up: priceDatas[0].chg > 0, down: priceDatas[0].chg < 0 }"
								@click="getDetailPriceData(0, priceDatas[0].n_code, priceDatas[0].name)">
								<div class="ctitle">{{ priceDatas[0].name }}</div>
								<div class="cbottom">
									<span class="cprice">{{ priceDatas[0].data }}</span>
									<span class="arrow">
										<img v-if="priceDatas[0].chg > 0" src="../../assets/images/arrow-up.png"
											style="transform: rotate(180deg);" />
										<img v-if="priceDatas[0].chg < 0" src="../../assets/images/arrow-down.png" />
										&nbsp;{{ Math.abs(priceDatas[0].chg) }}
									</span>

									<img class="btn" src="../../assets/images/price/按钮.png" />

									<div class="cdate">
										{{ priceDatas[0].rq }}
									</div>
								</div>
							</div>
							<div class="citem" :class="{ up: priceDatas[1].chg > 0, down: priceDatas[1].chg < 0 }"
								@click="getDetailPriceData(1, priceDatas[1].n_code, priceDatas[1].name)">
								<div class="ctitle">{{ priceDatas[1].name }}</div>
								<div class="cbottom">
									<span class="cprice">{{ priceDatas[1].data }}</span>
									<span class="arrow">
										<img v-if="priceDatas[1].chg > 0" src="../../assets/images/arrow-up.png"
											style="transform: rotate(180deg);" />
										<img v-if="priceDatas[1].chg < 0" src="../../assets/images/arrow-down.png" />
										&nbsp;{{ Math.abs(priceDatas[1].chg) }}
									</span>

									<img class="btn" src="../../assets/images/price/按钮.png" />

									<div class="cdate">
										{{ priceDatas[1].rq }}
									</div>
								</div>
							</div>
							<div class="citem" :class="{ up: priceDatas[2][0].chg > 0, down: priceDatas[2][0].chg < 0 }"
								@click="getDetailPriceData(2, priceDatas[2][0].n_code, priceDatas[2][0].name)"
								v-if="priceDatas && priceDatas[2] && priceDatas[2].length > 0">
								<div class="ctitle">{{ priceDatas[2][0].name }}</div>
								<div class="cbottom">
									<span class="cprice">{{ priceDatas[2][0].data }}</span>
									<span class="arrow">
										<img v-if="priceDatas[2][0].chg > 0" src="../../assets/images/arrow-up.png"
											style="transform: rotate(180deg);" />
										<img v-if="priceDatas[2][0].chg < 0" src="../../assets/images/arrow-down.png" />
										&nbsp;{{ Math.abs(priceDatas[2][0].chg) }}
									</span>

									<img class="btn" src="../../assets/images/price/按钮.png" />

									<div class="cdate">
										{{ priceDatas[2][0].rq }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="item r">
						<div class="title"></div>

						<div class="content">
							<div class="citem" :class="{ up: priceDatas[3].chg > 0, down: priceDatas[3].chg < 0 }"
								@click="getDetailPriceData(3, priceDatas[3].n_code, priceDatas[3].name)">
								<div class="ctitle">{{ priceDatas[3].name }}</div>
								<div class="cbottom">
									<span class="cprice">{{ priceDatas[3].data }}</span>
									<span class="arrow">
										<img v-if="priceDatas[3].chg > 0" src="../../assets/images/arrow-up.png"
											style="transform: rotate(180deg);" />
										<img v-if="priceDatas[3].chg < 0" src="../../assets/images/arrow-down.png" />
										&nbsp;{{ Math.abs(priceDatas[3].chg) }}
									</span>

									<img class="btn" src="../../assets/images/price/按钮.png" />

									<div class="cdate">
										{{ priceDatas[3].rq }}
									</div>
								</div>
							</div>

							<div class="citem" :class="{ up: priceDatas[4].chg > 0, down: priceDatas[4].chg < 0 }"
								@click="getDetailPriceData(4, priceDatas[4].n_code, priceDatas[4].name)">
								<div class="ctitle">{{ priceDatas[4].name }}</div>
								<div class="cbottom">
									<span class="cprice">{{ priceDatas[4].data }}</span>
									<span class="arrow">
										<img v-if="priceDatas[4].chg > 0" src="../../assets/images/arrow-up.png"
											style="transform: rotate(180deg);" />
										<img v-if="priceDatas[4].chg < 0" src="../../assets/images/arrow-down.png" />
										&nbsp;{{ Math.abs(priceDatas[4].chg) }}
									</span>
									<div class="cdate">
										{{ priceDatas[4].rq }}
									</div>
								</div>
							</div>

							<div class="citem" :class="{ up: priceDatas[5].chg > 0, down: priceDatas[5].chg < 0 }"
								@click="getDetailPriceData(5, priceDatas[5].n_code, priceDatas[5].name)">
								<div class="ctitle" style="font-size: 14px;margin-bottom: 2px;">{{ priceDatas[5].name }}
								</div>
								<div class="cbottom">
									<span class="cprice">{{ priceDatas[5].data }}</span>
									<span class="arrow">
										<img v-if="priceDatas[5].chg > 0" src="../../assets/images/arrow-up.png"
											style="transform: rotate(180deg);" />
										<img v-if="priceDatas[5].chg < 0" src="../../assets/images/arrow-down.png" />
										&nbsp;{{ Math.abs(priceDatas[5].chg) }}
									</span>

									<img class="btn" src="../../assets/images/price/按钮.png" />

									<div class="cdate">
										{{ priceDatas[5].rq }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 轮播图部分 start -->
				<div class="index-part-2">
					<div class="inlineBlock index-swipper">
						<el-carousel height="266px">
							<el-carousel-item v-for="(item, index) in (adIDsIndex[0] ? adIDsIndex[0]['list'] : [])"
								:key="index">
								<a :href="item.adLink" target="_blank">
									<img :src="item.adPicturePath" alt="" srcset="">
								</a>
							</el-carousel-item>
						</el-carousel>
					</div>

					<div class="inlineBlock index-part-2-center">
						<div class="pointer" @click="goInforDetailPage(consult_sel_all_center[0])"
							style="min-height: 127px;">
							<img :src="(consult_sel_all_center.length > 0 && consult_sel_all_center[0].pic != '' ? ('data:image/jpeg;base64,' + consult_sel_all_center[0].pic) : '../../assets/images/default.png')"
								alt="" srcset="">
							<a
								class="fontWhite textCenter w100">{{ consult_sel_all_center.length > 0 ? consult_sel_all_center[0].the_title : '' }}</a>
						</div>
						<div class="pointer" @click="goInforDetailPage(consult_sel_all_center[1])"
							style="min-height: 127px;">
							<img :src="(consult_sel_all_center.length > 0 && consult_sel_all_center[1].pic != '' ? ('data:image/jpeg;base64,' + consult_sel_all_center[1].pic) : '../../assets/images/default.png')"
								alt="" srcset="">
							<a
								class="fontWhite textCenter w100">{{ consult_sel_all_center.length > 0 ? consult_sel_all_center[1].the_title : '' }}</a>
						</div>
					</div>

					<div class="inlineBlock index-part-2-right p15 bgWhite" style="height: 239px;">
						<p style="margin-bottom: 10px;"><img src="../../assets/images/hangye_rddh.png" alt="" srcset="">
						</p>
						<div class="hot-list w100 fontLight" v-for="(item, index) in consult_sel_all" :key="index"
							@click="goInforDetailPage(item)">
							<router-link :to="'inforDetail/' + item.primary_id">【{{ item.type_name }}】
								{{ item.the_title }}
							</router-link>
						</div>
					</div>
				</div>
				<!-- 轮播图部分 end -->

				<!-- 第三部分 start -->
				<div class="index-part-3 mw-modular-box bgWhite p15 border">
					<el-row :gutter="20">
						<el-col :span="6" v-for="(item, index) in searchReport_list" :key="index">
							<div class="grid-content">
								<h3><span class="inlineBlock vMid"></span>
									{{ reportClassify[item.name] ? reportClassify[item.name] : item.name }}
								</h3>
								<div class="bgGrey pointer" @click="goReportDetailPage(item.data ? item.data[0] : '')">
									<div class="inlineBlock vTop sd-img-box">
										<div>
											<img src="../../assets/images/report_fx_pz.png" alt srcset
												v-if="item.name == '唐宋100指数报告-分品种'" />
											<img src="../../assets/images/report_fx.png" alt srcset
												v-else-if="item.name == '唐宋100指数（周）报告'" />
											<img src="../../assets/images/report_tejrb.png" alt srcset
												v-else-if="item.name == '唐尔街日报'" />
											<img src="../../assets/images/report_hysd.png" alt srcset
												v-else-if="item.name == '监测预警周报'" />
											<img src="../../assets/images/report_hysd.png" alt srcset v-else />
										</div>
									</div>
									<div class="inlineBlock vTop sd-main-box" v-if="item.data.length > 0">
										<h4 class="fontNormal font14" :title="item.data[0].reportTitle">
											{{ item.data[0].reportTitle.length > 10 ? (item.data[0].reportTitle.substr(0, 10) + '...') : item.data[0].reportTitle }}
										</h4>
										<p class="fontLight">
											{{ item.data[0].abstractText.length > 26 ? (item.data[0].abstractText.substr(0, 26) + '[详情]') : item.data[0].abstractText }}
										</p>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- 第三部分 end -->

				<div v-if="adIDsIndex[1]['list']">
					<a v-for="(item, index) in adIDsIndex[1]['list']" :key="index" :href="item.adLink" target="_blank"
						class="w100 block" style="margin-top: -10px; margin-bottom: -10px;">
						<img :src="item.adPicturePath" alt="" class="w100">
					</a>
				</div>


				<!-- 新增视频模块 20210728 start (暂时隐藏) -->
				<!-- <div class="mw-modular-box bgWhite w100 index-video-part" style="margin-bottom: 10px;">
					<div class="i-v-types">

						<p class="inlineBlock" style="margin-right: 30px;">
							<a style="background: #a30000; line-height: 25px; width: 45px; margin-right: 5px;"
								class="fontWhite font16 inlineBlock textCenter fontBold">唐宋</a>
							<a class="font16 fontBold">视频</a>
						</p>
						<span class="inlineBlock font14 textCenter pointer" v-for="(item, index) in videoType"
							:key="index" :class="{'active': videoTypeId == item.typeId}"
							@click="changeVideoType(item.typeId)">{{ item.typeName }}</span>

					</div>
					<div class="i-v-list">
						<el-row :gutter="20">
							<el-col :span="10">
								<div class="i-v-list-lg posRel" @click="goVideoPage(item.viId)"
									v-for="(item, index) in videoListTop" :key="index">
									<img :src="item.videoPicUrl" class="w100" height="310px" alt="" srcset="">
									<p class="posAbs ellipsis w100 font14">{{ item.title }}</p>
								</div>
							</el-col>
							<el-col :span="14">
								<el-row :gutter="20">
									<el-col :span="8" v-for="(item, index) in videoList" :key="index">
										<div class="i-v-list-sm " @click="goVideoPage(item.viId)">
											<img :src="item.videoPicUrl" class="w100" height="130px" alt="" srcset="">
											<p class=" w100 font14 ellipsis">{{ item.title }}</p>
										</div>
									</el-col>

								</el-row>
							</el-col>
						</el-row>
					</div>
				</div> -->
				<!-- 新增视频模块 20210728 end -->

				<!-- 周保定月 banner -->
				<div class="mw-modular-box bgWhite w100" style="margin-bottom: 10px;">
					<img :src="require('../../assets/images/zhoubaodingyue2.jpg')" class="w100" alt="banner">
				</div>



				<!-- <img src="../../assets/images/tsjizhunjia.png" alt="" srcset=""> -->
				<!-- <span class="inlineBlock font14 textCenter">分类2</span>
                    <span class="inlineBlock font14 textCenter">分类3</span> -->
				<!-- <el-col :span="8">
                        <div class="i-v-list-sm ">
                            <img src="../../assets/images/aboutus_1.png" class="w100" height="150px" alt="" srcset="">
                            <p class=" w100 font14">这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="i-v-list-sm ">
                            <img src="../../assets/images/aboutus_1.png" class="w100" height="150px" alt="" srcset="">
                            <p class=" w100 font14">这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="i-v-list-sm ">
                            <img src="../../assets/images/aboutus_1.png" class="w100" height="150px" alt="" srcset="">
                            <p class=" w100 font14">这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="i-v-list-sm ">
                            <img src="../../assets/images/aboutus_1.png" class="w100" height="150px" alt="" srcset="">
                            <p class=" w100 font14">这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="i-v-list-sm ">
                            <img src="../../assets/images/aboutus_1.png" class="w100" height="150px" alt="" srcset="">
                            <p class=" w100 font14">这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111这是一段描述文字111111111</p>
                        </div>
                    </el-col> -->
				<!-- 新增视频模块 20210728 end -->

				<!-- 新增企业报价 0226 start -->
				<div class="index-quote bgWhite w100"
					v-if="(varietiesType == '' && varTableList.length != 0) || (varietiesType != '')">

					<ul class="w100 quote-varieties-box">
						<li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter"
								:class="{'active': varietiesType == ''}" @click="changeVarieties('')">全部</a></li>
						<li v-for="(item, index) in varietiesList" :key="index">
							<a href="javascript:;" class="block fontNormal fontBold font14 textCenter"
								:class="{'active': varietiesType == item.id}"
								@click="changeVarieties(item.id)">{{ item.name }}</a>
						</li>
						<!-- <li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter" :class="{'active': varietiesType == 'other'}" style="margin-right: -1px;" @click="changeVarieties('other')">其他</a></li> -->
					</ul>
					<div style="margin-top: 20px;">
						<el-row :gutter="20">
							<el-col :span="18">
								<div style="padding: 0 10px;" class="index-quote-list-box" v-show="!varIsNone">
									<ul v-for="(item, index) in varTableList" :key="index">
										<li class="inlineBlock font14 fontRed" style="width: 200px; padding-left: 5px;">
											<!-- <img src="../../assets/images/quote_gongsi.png" alt="" style="width: 16px; height: 16px; margin-right: 5px; margin-top: -2px;" class="vMid inlineBlock"> -->
											<a href="javascript:;"
												class="inlineBlock quote-enterprise-name ellipsis vMid"
												:style="{'width': item.benchmarkStatus || item.recommendStatus ? '72%' : '100%'}"
												@click="goQuoteDetail(item.userPhone)"
												:title="item.enterpriseName">{{ item.enterpriseName }}</a>
											<small class="fontRed inlineBlock vMid textCenter"
												v-show="item.benchmarkStatus">基</small>
											<small class="fontRed inlineBlock vMid textCenter"
												v-show="item.recommendStatus">荐</small>
										</li>
										<li class="inlineBlock font14 fontBold ellipsis vMid textCenter"
											style="width: 100px" :title="item.varietiesName">
											{{ item.varietiesName || '' }}
										</li>
										<li class="inlineBlock font14 fontLight ellipsis vMid"
											style="width: 110px; padding-right: 10px; box-sizing: border-box;"
											:title="item.attribute0">
											{{ item.attribute0 || '' }}
										</li>
										<li class="inlineBlock font14 fontLight ellipsis vMid" style="width: 110px"
											:title="item.attribute1">
											{{ item.attribute1 || '' }}
										</li>
										<li class="inlineBlock font14 fontRedLight fontBold vMid textCenter"
											style="width: 80px">{{ item.price }}</li>
										<li class="inlineBlock font14 fontLight vMid" style="width: 110px">
											{{ item.offerDate }}
										</li>
										<li class="inlineBlock font14 fontLight vMid" style="width: 160px">
											<a href="javascript:;" class="button inlineBlock"
												style="margin-right: 10px;" @click="goQuote()">全部报价</a>
											<a href="javascript:;" class="button inlineBlock"
												@click="goQuote(item.varietiesType)">品种报价</a>
										</li>
									</ul>
								</div>
								<div class="textCenter font16" v-show="varIsNone">暂无报价信息~</div>
							</el-col>
							<el-col :span="6">
								<!-- <img src="../../assets/images/index_quote_img.jpg" class="w100" style="height: 240px;" alt=""> -->
								<div v-if="adIDsIndex[7]['list']">
									<a v-for="(item, index) in adIDsIndex[7]['list']" :key="index" :href="item.adLink"
										target="_blank" class="w100 block"
										style="margin-top: 0px; margin-bottom: 10px;">
										<img :src="item.adPicturePath" alt="" class="w100">
									</a>
								</div>
							</el-col>
						</el-row>
					</div>


				</div>
				<!-- 新增企业报价 0226 end -->


				<div v-if="adIDsIndex[12] && adIDsIndex[12]['list']">
					<a v-for="(item, index) in adIDsIndex[12]['list']" :key="index" :href="item.adLink" target="_blank"
						class="w100 block" style="margin-top: 20px;">
						<img :src="item.adPicturePath" alt="" class="w100">
					</a>
				</div>

				<!-- 第四部分 start zhangziao-->
				<!--                <div class="index-part-4 mw-modular-box bgWhite p15 border">
                    <h3><img src="../../assets/images/tsjizhunjia.png" alt=""></h3>
                    <div class="jz-price">
                        <div class="swiper-container swiper-container-2">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, index) in basePrice_list" :key="index">
                                    <div class="grid-content textCenter p10 pointer" :class="{bgGrey: basePriceTab === (item.tag == 'MJ' ? (item.tag + '_' + item.type) : item.tag)}" @click="changeBasePrice(item)">
                                        <h4 class="font16 fontNormal">{{ item.basePriceName }}</h4>
                                        <div class="jz-price-main fontBold">
                                            <div class="inlineBlock vTop fontBold" style="font-size: 30px; margin-top: -3px" :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.price }}</div>
                                            <div class="inlineBlock vTop textLeft" style="padding-left: 6px" :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">
                                                <small class="">{{ item.chg > 0 ? '+' + item.chg : item.chg }}</small> <br>
                                                <small class="">{{ item.chg > 0 ? '+' + item.chgRadio.toFixed(2) : item.chgRadio.toFixed(2) }}%</small>
                                            </div>
                                        </div>
                                        <small class="textLighter">{{ item.dataDate }}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-button-next"></div>
                            <div class="swiper-button-prev"></div>
                        </div>

                        <el-row :gutter="20" style="margin-top: 30px;">
                            <el-col :span="18">
                                <div class="map-box">
                                    <div class="map-classify p10">
                                        <p v-for="(item, index) in basePriceProduct_list" :key="index" :class="{active: basePriceProduct_id == item.key}" class="pointer" @click="changeMapClassify(item.key)"><span class="circle"></span>{{ item.val }}</p>
                                    </div>
                                    <div class="grid-content bgGrey" @click="goBasicPrice"
                                        v-loading="mapLoading"
                                        element-loading-text="拼命加载中"
                                        element-loading-spinner="el-icon-loading"
                                        element-loading-background="rgba(255, 255, 255, 1)"
                                    >
                                        <div ref="mapChart" class="w100" style="height: 572px"></div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="grid-content">
                                    <h3><span class="inlineBlock vMid"></span> {{ basePriceTable_title }} <a class="map-box-more pointer" @click="goBasicPrice">更多+</a> </h3>
                                    <div class="mw-table-grid">
                                        <div class="mw-table-row" v-for="(item, index) in basePriceTable_list" :key="index">
                                            <div style="flex: 0 22%;">{{ item.areaName }}</div>
                                            <div style="flex: 0 16%;">{{ item.price }}元</div>
                                            <div style="flex: 0 12%;" :class="{'fontRed': item.chg > 0, 'fontGreen': item.chg < 0, 'fontNormal': item.chg == 0}">{{ item.chg }}</div>
                                            <div style="flex: 0 16%;" :class="{'fontRed': item.chg > 0, 'fontGreen': item.chg < 0, 'fontNormal': item.chg == 0}">{{ item.chgRadio ? item.chgRadio.toFixed(2) : 0.00 }}%</div>
                                            <div style="flex: 0 34%;">{{ item.dataDate }}</div>
                                        </div>
                                    </div>
                                    <a v-for="(item, index) in adIDsIndex[2]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: 10px;">
                                        <img :src="item.adPicturePath" alt="" style="width: 293px; height: 112px;">
                                    </a>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div> -->
				<div class="index-part-4 mw-modular-box bgWhite p15 border">
					<h3><img src="../../assets/images/tsjizhunjia.png" alt=""> <a class="map-box-more pointer"
							@click="goBasicPrice">更多+</a> </h3>
					<div class="jz-price">
						<el-row :gutter="24">
							<el-col :span="4" v-for="(item, index) in basePrice_list" :key="index"
								class="jzj-bg-ground">
								<div v-if="index<6" class="grid-content textCenter p10 pointer"
									:class="{bgGrey: basePriceTab === (item.tag == 'MJ' ? (item.tag + '_' + item.type) : item.tag)}"
									@click="changeBasePrice(item)">
									<h4 class="font16 fontNormal">{{ item.basePriceName }}</h4>
									<div class="jz-price-main fontBold">
										<div class="inlineBlock vTop fontBold" style="font-size: 30px; margin-top: -3px"
											:class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">
											{{ item.price }}
										</div>
										<div class="inlineBlock vTop textLeft" style="padding-left: 6px"
											:class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">
											<small class="">{{ item.chg > 0 ? '+' + item.chg : item.chg }}</small> <br>
											<small
												class="">{{ item.chg > 0 ? '+' + item.chgRadio.toFixed(2) : item.chgRadio.toFixed(2) }}%</small>
										</div>
									</div>
									<small class="textLighter">{{ item.dataDate }}</small>
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="16">
								<div class="map-box">
									<div class="map-classify p10">
										<p v-for="(item, index) in basePriceProduct_list" :key="index"
											:class="{active: basePriceProduct_id == item.key}" class="pointer"
											@click="changeMapClassify(item.key)"><span
												class="circle"></span>{{ item.val }}</p>
									</div>
									<div class="grid-content bgGrey" @click="goBasicPrice" v-loading="mapLoading"
										element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
										element-loading-background="rgba(255, 255, 255, 1)">
										<!-- 地图 start -->
										<div ref="mapChart" class="w100" style="height: 615px"></div>
										<!-- 地图 end -->
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="grid-content" id="custom-jzj-list">
									<!-- <h3><span class="inlineBlock vMid"></span> {{ basePriceTable_title }} <a class="map-box-more pointer" @click="goBasicPrice">更多+</a> </h3> -->

									<el-tabs v-model="basePriceProduct_id" @tab-click="handleClickChangeTab">
										<el-tab-pane v-for="(item, index) in basePriceProduct_list" :label="item.val"
											:name="item.key">
											<div class="mw-table-grid">
												<div class="mw-table-row" v-for="(item, index) in basePriceTable_list"
													:key="index">
													<div style="flex: 0 22%;">{{ item.areaName }}</div>
													<div style="flex: 0 16%;">{{ item.price }}元</div>
													<div style="flex: 0 12%;"
														:class="{'fontRed': item.chg > 0, 'fontGreen': item.chg < 0, 'fontNormal': item.chg == 0}">
														{{ item.chg }}
													</div>
													<div style="flex: 0 16%;"
														:class="{'fontRed': item.chg > 0, 'fontGreen': item.chg < 0, 'fontNormal': item.chg == 0}">
														{{ item.chgRadio ? item.chgRadio.toFixed(2) : 0.00 }}%
													</div>
													<div style="flex: 0 34%;">{{ item.dataDate }}</div>
												</div>
											</div>
										</el-tab-pane>
									</el-tabs>
									<!-- 				                    <a v-for="(item, index) in adIDsIndex[2]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: 10px;">
								                        <img :src="item.adPicturePath" alt="" style="width: 293px; height: 112px;">
								                    </a> -->
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="24">
							<el-col :span="4" v-for="(item, index) in basePrice_list" :key="index"
								class="jzj-bg-ground">
								<div v-if="index>5" class="grid-content textCenter p10 pointer"
									:class="{bgGrey: basePriceTab === (item.tag == 'MJ' ? (item.tag + '_' + item.type) : item.tag)}"
									@click="changeBasePrice(item)">
									<h4 class="font16 fontNormal">{{ item.basePriceName }}</h4>
									<div class="jz-price-main fontBold">
										<div class="inlineBlock vTop fontBold" style="font-size: 30px; margin-top: -3px"
											:class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">
											{{ item.price }}
										</div>
										<div class="inlineBlock vTop textLeft" style="padding-left: 6px"
											:class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">
											<small class="">{{ item.chg > 0 ? '+' + item.chg : item.chg }}</small> <br>
											<small
												class="">{{ item.chg > 0 ? '+' + item.chgRadio.toFixed(2) : item.chgRadio.toFixed(2) }}%</small>
										</div>
									</div>
									<small class="textLighter">{{ item.dataDate }}</small>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
				<!-- 第四部分 end -->

				<el-row :gutter="15" style="margin-top: 0px; margin-bottom: -10px;" v-if="adIDsIndex[3]['list']">
					<el-col :span="8" v-for="(item, index) in adIDsIndex[3]['list']" :key="index">
						<a :href="item.adLink" target="_blank" class="w100 block">
							<img :src="item.adPicturePath" alt="" class="w100">
						</a>
					</el-col>
				</el-row>
				<div style="background-color: #fafafa;padding: 20px 0px;">
					<el-row :gutter="15">
						<el-col :span="16">
							<div id="custom-jiage">
								<div class="custom-title"
									style="padding:0px 10px; border: solid 1px #eaeaea; margin-bottom: 10px; height: 60px;background-color: #fff;display: -webkit-flex;display: flex;justify-content:space-between;align-items:center;">
									<div
										style="display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
										<img style="height:20px;margin-right: 15px;"
											src="../../assets/images/tsjg.png" />
										<span @click="handleClickJiage" data-index="0"
											v-show="selectjiage!='1'&&selectjiage!='2'"
											style="height:30px;width:80px;line-height:30px;background-color: #f8f7fc;border-radius: 10px;margin-right: 15px;text-align: center;cursor: pointer;"
											:class="clickjiage=='0'?'custom-bg-r':''">市场价</span>
										<span @click="handleClickJiage" data-index="1"
											v-show="selectjiage!='0'&&selectjiage!='3'&&selectjiage!='6'"
											style="height:30px;width:80px;line-height:30px;background-color: #f8f7fc;border-radius: 10px;margin-right: 15px;text-align: center;cursor: pointer;"
											:class="clickjiage=='1'?'custom-bg-r':''">出厂价</span>
									</div>
									<a @click="goAllPrice"
										style="font-size: 14px;font-weight: 700;cursor: pointer;">更多+</a>
								</div>
								<div>
									<el-row :gutter="15">
										<el-col :span="3">
											<el-menu default-active="4" class="el-menu-vertical-demo"
												@select="handleSelectJiage" style="border: solid 1px #eaeaea;">
												<el-menu-item index="4"><span slot="title">螺纹</span></el-menu-item>
												<el-menu-item index="5"><span slot="title">线材</span></el-menu-item>
												<el-menu-item index="7"><span slot="title">带钢</span></el-menu-item>
												<el-menu-item index="6"><span slot="title">板材</span></el-menu-item>
												<el-menu-item index="8"><span slot="title">型钢</span></el-menu-item>
												<el-menu-item index="9"><span slot="title">管材</span></el-menu-item>
												<el-menu-item index="3"><span slot="title">废钢</span></el-menu-item>
												<el-menu-item index="2"><span slot="title">钢坯</span></el-menu-item>
												<el-menu-item index="0"><span slot="title">铁矿石</span></el-menu-item>
												<el-menu-item index="1"><span slot="title">煤焦</span></el-menu-item>
											</el-menu>
										</el-col>
										<el-col :span="21">
											<div
												style="background-color: #ffffff;border: solid 1px #eaeaea;padding: 14px 15px;">
												<el-table id="custom-jg-table" :data="jiage_tableData" size="mini"
													border stripe
													:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}"
													:cell-style="{'height':'33px','line-height':'33px','padding':'0px 0px'}"
													style="font-size: 12px;width: 100%;">
													<el-table-column width="85" prop="productName" label="品名">
													</el-table-column>
													<el-table-column width="50" prop="price" label="价格">
													</el-table-column>
													<!-- <el-table-column width="60" prop="unitName" label="单位"></el-table-column> -->
													<el-table-column width="50" prop="chg" label="涨跌"></el-table-column>
													<el-table-column width="190" label="材质/规格">
														<template slot-scope="scope">
															{{scope.row.texture?scope.row.texture:'-'}}/{{scope.row.standard?scope.row.standard:'-'}}
														</template>
													</el-table-column>
													<!-- <el-table-column prop="priceFormName" label="价格形式"></el-table-column> -->
													<template v-if="clickjiage=='0'">
														<el-table-column width="95" prop="marketName" label="市场">
														</el-table-column>
													</template>
													<template v-if="clickjiage=='1'">
														<el-table-column width="95" prop="originName" label="产地">
														</el-table-column>
													</template>
													<el-table-column width="120" prop="enterpriseName" label="企业">
													</el-table-column>
													<el-table-column width="70" label="更新日期">
														<template slot-scope="scope">
															{{scope.row.dataDate.substr(5)}}
														</template>
													</el-table-column>
												</el-table>
											</div>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="custom-title"
								style="padding:0px 10px; border: solid 1px #eaeaea; margin-bottom: 10px; height: 60px;background-color: #fff;display: -webkit-flex;display: flex;justify-content:space-between;align-items:center;">
								<div
									style="display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<img style="height:20px;margin-right: 15px;" src="../../assets/images/tscblr.png" />
								</div>
							</div>
							<el-table id="custom-cblr-table" :data="cblr_tableData" style="width: 100%;font-size: 12px;"
								border stripe
								:header-cell-style="{'color':'#a30000','text-align': 'center','height':'51px'}"
								:cell-style="{'height':'51px'}">
								<el-table-column prop="mc" label="指标名称"></el-table-column>
								<el-table-column prop="cb" label="成本(元/吨)"></el-table-column>
								<el-table-column prop="lr" label="利润(元/吨)"></el-table-column>
								<el-table-column prop="rq" label="日期"></el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</div>
				<el-row :gutter="15" style="margin-top: 0px; margin-bottom: 0px;">
					<el-col :span="16" v-if="adIDsIndex[4]['list']">
						<el-row :gutter="10">
							<el-col :span="8" v-for="(item, index) in adIDsIndex[4]['list']" :key="index">
								<a :href="item.adLink" target="_blank" class="w100 block">
									<img :src="item.adPicturePath" alt="" class="w100" style="height: 65px">
								</a>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="8" v-if="adIDsIndex[5]['list']">
						<a v-for="(item, index) in adIDsIndex[5]['list']" :key="index" :href="item.adLink"
							target="_blank" class="w100 block">
							<img :src="item.adPicturePath" alt="" class="w100">
						</a>
					</el-col>
				</el-row>

				<div id="custom-kgl" style="background-color: #fafafa;padding: 20px 0px;">
					<div class="custom-title"
						style="padding:0px 10px; border: solid 1px #eaeaea; margin-bottom: 10px; height: 60px;background-color: #fff;display: -webkit-flex;display: flex;justify-content:space-between;align-items:center;">
						<div style="display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
							<img style="height:20px;margin-right: 15px;" src="../../assets/images/tskgl.png" />
							<span
								style="height:30px;width:80px;line-height:30px;background-color: #f8f7fc;border-radius: 10px;margin-right: 15px;text-align: center;cursor: pointer;"
								class="custom-bg-r">开工率</span>
						</div>
						<!-- <a @click="goGongYing" style="font-size: 14px;font-weight: 700;cursor: pointer;">更多+</a> -->
					</div>
					<el-row :gutter="15">
						<el-col :span="8">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										螺纹钢</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea; display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<span @click="handleClickGongying1" data-index="0"
										:class="clickgongying1=='0'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;text-align: center;cursor: pointer;">产能</span>
									<span @click="handleClickGongying1" data-index="1"
										:class="clickgongying1=='1'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">条数</span>
								</div>
								<el-table v-show="clickgongying1=='0'" :data="cn_lwg_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying1=='1'" :data="gs_lwg_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>

						<el-col :span="8">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										线材</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<span @click="handleClickGongying2" data-index="0"
										:class="clickgongying2=='0'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;text-align: center;cursor: pointer;">产能</span>
									<span @click="handleClickGongying2" data-index="1"
										:class="clickgongying2=='1'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">条数</span>
								</div>
								<el-table v-show="clickgongying2=='0'" :data="cn_xc_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="160" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="55" prop="data" label="当期值"></el-table-column>
									<el-table-column width="55" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying2=='1'" :data="gs_xc_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="160" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="55" prop="data" label="当期值"></el-table-column>
									<el-table-column width="55" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>

						<el-col :span="8">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										板材</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<span @click="handleClickGongying3" data-index="0"
										:class="clickgongying3=='0'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;text-align: center;cursor: pointer;">产能</span>
									<span @click="handleClickGongying3" data-index="1"
										:class="clickgongying3=='1'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">条数</span>
								</div>
								<el-table v-show="clickgongying3=='0'" :data="cn_bc_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying3=='1'" :data="gs_bc_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>



						<el-col :span="8" style="margin-top: 10px;">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										钢坯</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<span @click="handleClickGongying7" data-index="0"
										:class="clickgongying7=='0'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;text-align: center;cursor: pointer;">产能</span>
									<span @click="handleClickGongying7" data-index="1"
										:class="clickgongying7=='1'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">个数</span>
									<span @click="handleClickGongying7" data-index="2"
										:class="clickgongying7=='2'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">容积</span>
								</div>
								<el-table v-show="clickgongying7=='0'" :data="cn_gp_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying7=='1'" :data="gs_gp_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying7=='2'" :data="rj_gp_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>

						<el-col :span="8" style="margin-top: 10px;">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										型钢</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<span @click="handleClickGongying5" data-index="0"
										:class="clickgongying5=='0'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;text-align: center;cursor: pointer;">产能</span>
									<span @click="handleClickGongying5" data-index="1"
										:class="clickgongying5=='1'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">条数</span>
								</div>
								<el-table v-show="clickgongying5=='0'" :data="cn_xg_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="160" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="55" prop="data" label="当期值"></el-table-column>
									<el-table-column width="55" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying5=='1'" :data="gs_xg_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="160" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="55" prop="data" label="当期值"></el-table-column>
									<el-table-column width="55" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>

						<el-col :span="8" style="margin-top: 10px;">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										管材</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;height: 40px;">
								</div>
								<el-table v-show="clickgongying6=='0'" :data="cn_gc_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying6=='1'" :data="gs_gc_tableData" size="mini"
									style="font-size: 12px;" height="324"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>

						<el-col :span="8" style="margin-top: 10px;">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										带钢</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<span @click="handleClickGongying4" data-index="0"
										:class="clickgongying4=='0'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;text-align: center;cursor: pointer;">产能</span>
									<span @click="handleClickGongying4" data-index="1"
										:class="clickgongying4=='1'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">条数</span>
								</div>
								<el-table v-show="clickgongying4=='0'" :data="cn_dg_tableData" size="mini"
									style="font-size: 12px;" height="360"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="160" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.substring(0,scope.row.nodeName.length-3)}}
										</template>
									</el-table-column>
									<el-table-column width="55" prop="data" label="当期值"></el-table-column>
									<el-table-column width="55" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying4=='1'" :data="gs_dg_tableData" size="mini"
									style="font-size: 12px;" height="360"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="160" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.substring(0,scope.row.nodeName.length-3)}}
										</template>
									</el-table-column>
									<el-table-column width="55" prop="data" label="当期值"></el-table-column>
									<el-table-column width="55" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>

						<el-col :span="8" style="margin-top: 10px;">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										铁矿石</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;height: 40px;">
								</div>
								<el-table v-show="clickgongying9=='0'" :data="cn_tks_tableData" size="mini"
									style="font-size: 12px;" height="360"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>

						<el-col :span="8" style="margin-top: 10px;">
							<div style="border: solid 1px #eaeaea;">
								<div style="border-bottom: solid 1px #eaeaea;">
									<div
										style="font-size: 16px;font-weight: 700;border-top: solid 2px #a30000;border-right: solid 1px #eaeaea; width: 100px;text-align: center;line-height: 30px;">
										煤焦</div>
								</div>
								<div
									style="background-color: #ffffff;border-bottom: solid 1px #eaeaea;display: -webkit-flex;display: flex;justify-content:flex-start;align-items:center;">
									<span @click="handleClickGongying8" data-index="0"
										:class="clickgongying8=='0'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;text-align: center;cursor: pointer;">产能</span>
									<span @click="handleClickGongying8" data-index="1"
										:class="clickgongying8=='1'?'custom-bg-r':''"
										style="font-size:10px;height:20px;width:40px;line-height:20px;background-color: #f8f7fc;border-radius: 10px;margin:10px;margin-left:0px;text-align: center;cursor: pointer;">个数</span>
								</div>
								<el-table v-show="clickgongying8=='0'" :data="cn_mj_tableData" size="mini"
									style="font-size: 12px;" height="360"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table v-show="clickgongying8=='1'" :data="gs_mj_tableData" size="mini"
									style="font-size: 12px;" height="360"
									:header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}">
									<el-table-column width="55" label="日期">
										<template slot-scope="scope">
											{{scope.row.rq.substr(5)}}
										</template>
									</el-table-column>
									<el-table-column width="150" label="指标名称">
										<template slot-scope="scope">
											{{scope.row.nodeName.replace("（%）","")}}
										</template>
									</el-table-column>
									<el-table-column width="60" prop="data" label="当期值"></el-table-column>
									<el-table-column width="60" label="涨跌值">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.chg < 0, 'fontRed': scope.row.chg > 0, 'fontNormal': scope.row.chg == 0}">{{scope.row.chg}}</span>
										</template>
									</el-table-column>
									<el-table-column width="60" label="涨跌幅">
										<template slot-scope="scope">
											<span
												:class="{'fontGreen': scope.row.range < 0, 'fontRed': scope.row.range > 0, 'fontNormal': scope.row.range == 0}">{{scope.row.range}}%</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-col>


					</el-row>
				</div>

				<el-row :gutter="15" style="margin-top: 0px; margin-bottom: 0px;">
					<el-col :span="16" v-if="adIDsIndex[9]['list']">
						<el-row :gutter="10">
							<el-col :span="8" v-for="(item, index) in adIDsIndex[9]['list']" :key="index">
								<a :href="item.adLink" target="_blank" class="w100 block">
									<img :src="item.adPicturePath" alt="" class="w100" style="height: 65px">
								</a>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="8" v-if="adIDsIndex[10]['list']">
						<a v-for="(item, index) in adIDsIndex[10]['list']" :key="index" :href="item.adLink"
							target="_blank" class="w100 block">
							<img :src="item.adPicturePath" alt="" class="w100">
						</a>
					</el-col>
				</el-row>


				<!-- 第五部分 start -->
				<div class="index-part-5 mw-modular-box">
					<el-row :gutter="15">
						<el-col :span="16">
							<div class="grid-content">
								<!-- <a :href="adIDsIndex[4] ? ( adIDsIndex[4]['list'].length > 0 ? adIDsIndex[4]['list'][0]['adLink'] : '') : ''" target="_blank" rel="" class="block w100" style="margin-bottom: 20px; height: 102px;">
                                    <img :src="adIDsIndex[4] ? ( adIDsIndex[4]['list'].length > 0 ? adIDsIndex[4]['list'][0]['adPicturePath'] : '') : ''" alt="" srcset="" class="w100">
                                </a> -->

								<div class="part-tab bgWhite p15" style="min-height: 700px;">
									<div class="part-tab-list">
										<el-tabs v-model="inforTabName" @tab-click="inforTabChange" class="textCenter">
											<el-tab-pane label="资讯推荐" name="0">
												<div v-show="inforTable_list2.length > 0">
													<div v-for="(cItem, cIndex) in inforTable_list2" :key="cIndex">
														<div class="part-tab-clist pointer" v-show="cItem.pic"
															@click="goInforDetailPage(cItem)">
															<span class="tag"
																:title="cItem.type_name">{{ cItem.type_name }}</span>
															<div style="flex: 1;"> <img
																	:src="'data:image/jpeg;base64,' + cItem.pic" alt=""
																	srcset=""> </div>
															<div style="flex: 4;" class="w100 textLeft main">
																<h4 class="font16 fontBold fontNormal">
																	{{ cItem.the_title }}
																</h4>
																<div class="main-sub fontLight">{{ cItem.overview }}
																</div>
																<div class="main-tags-box">
																	<span v-if="cItem.the_table">
																		<span
																			v-for="(table, tableI) in cItem.the_table.split(',')"
																			:key="tableI" style="margin-right: 5px;"
																			class="inlineBlock">
																			<span class="main-tag fontRed pointer"
																				v-if="table"
																				@click.stop="goSearchPage(table)">{{ table }}</span>
																		</span>
																	</span>
																	<span
																		v-if="cItem.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ cItem.oper_man ? cItem.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ compareTime(cItem.create_date) }}</span>
																</div>
															</div>
														</div>
														<div class="part-tab-clist pointer" v-show="!cItem.pic"
															style="border-bottom: 1px solid #eee;"
															@click="goInforDetailPage(cItem)">
															<span class="tag"
																:title="cItem.type_name">{{ cItem.type_name }}</span>
															<div class="w100 textLeft main" style="padding-left: 10px">
																<h4 class="font16 fontBold fontNormal"
																	style="margin-left: 70px">{{ cItem.the_title }}</h4>
																<div class="main-sub fontLight">{{ cItem.overview }}
																</div>
																<div class="main-tags-box">
																	<span v-if="cItem.the_table">
																		<span
																			v-for="(table, tableI) in cItem.the_table.split(',')"
																			:key="tableI" style="margin-right: 5px;"
																			class="inlineBlock">
																			<span class="main-tag fontRed pointer"
																				v-if="table"
																				@click.stop="goSearchPage(table)">{{ table }}</span>
																		</span>
																	</span>
																	<span
																		v-if="cItem.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ cItem.oper_man ? cItem.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ compareTime(cItem.create_date) }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div v-show="inforTable_list2.length == 0" class="p20 textCenter">
													暂无资讯信息~</div>
											</el-tab-pane>
											<el-tab-pane :label="item.type_name" :name="item.consult_id"
												v-for="(item, index) in inforTab_list" :key="index">
												<div v-show="inforTable_list2.length > 0">
													<div v-for="(cItem, cIndex) in inforTable_list2" :key="cIndex">
														<div class="part-tab-clist pointer" v-show="cItem.pic"
															@click="goInforDetailPage(cItem)">
															<span class="tag"
																:title="cItem.type_name">{{ cItem.type_name }}</span>
															<div style="flex: 1;"> <img
																	:src="'data:image/jpeg;base64,' + cItem.pic" alt=""
																	srcset=""> </div>
															<div style="flex: 4;" class="w100 textLeft main">
																<h4 class="font16 fontBold fontNormal">
																	{{ cItem.the_title }}
																</h4>
																<div class="main-sub fontLight">{{ cItem.overview }}
																</div>
																<div class="main-tags-box">
																	<span v-if="cItem.the_table">
																		<span
																			v-for="(table, tableI) in cItem.the_table.split(',')"
																			:key="tableI" style="margin-right: 5px;"
																			class="inlineBlock">
																			<span class="main-tag fontRed pointer"
																				v-if="table"
																				@click.stop="goSearchPage(table)">{{ table }}</span>
																		</span>
																	</span>
																	<span
																		v-if="cItem.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ cItem.oper_man ? cItem.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ compareTime(cItem.create_date) }}</span>
																</div>
															</div>
														</div>
														<div class="part-tab-clist pointer" v-show="!cItem.pic"
															style="border-bottom: 1px solid #eee;"
															@click="goInforDetailPage(cItem)">
															<span class="tag"
																:title="cItem.type_name">{{ cItem.type_name }}</span>
															<div class="w100 textLeft main" style="padding-left: 10px">
																<h4 class="font16 fontBold fontNormal"
																	style="margin-left: 70px">{{ cItem.the_title }}</h4>
																<div class="main-sub fontLight">{{ cItem.overview }}
																</div>
																<div class="main-tags-box">
																	<span v-if="cItem.the_table">
																		<span
																			v-for="(table, tableI) in cItem.the_table.split(',')"
																			:key="tableI" style="margin-right: 5px;"
																			class="inlineBlock">
																			<span class="main-tag fontRed pointer"
																				v-if="table"
																				@click.stop="goSearchPage(table)">{{ table }}</span>
																		</span>
																	</span>
																	<span
																		v-if="cItem.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ cItem.oper_man ? cItem.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
																	<span>{{ compareTime(cItem.create_date) }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div v-show="inforTable_list2.length == 0" class="p20 textCenter">
													暂无资讯信息~</div>
											</el-tab-pane>
										</el-tabs>
									</div>
								</div>

								<el-row :gutter="15" style="margin-top: 10px; margin-bottom: -10px; padding: 0 15px"
									v-if="adIDsIndex[11]['list']">
									<el-col :span="8" v-for="(item, index) in adIDsIndex[11]['list']" :key="index">
										<a :href="item.adLink" target="_blank" class="w100 block">
											<img :src="item.adPicturePath" alt="" class="w100">
										</a>
									</el-col>
								</el-row>


								<div class="report-box bgWhite p15" style="height: 254px;">
									<h3><span>研报推荐</span></h3>
									<div class="report-list inlineBlock vTop pointer"
										v-for="(item, index) in searchFourReport_list" :key="index"
										@click="goReportDetailPage(item)"
										:style="{ 'margin-left': index == 0 ? '12px' : 'auto' }">
										<div class="report-list-img center"
											:style="{ 'margin-left': index == 3 ? '10px' : (index== 2 ? '5px' : 'auto') }">
											<img src="../../assets/images/index_fx_pz.jpg" alt srcset
												v-if="item.sortName == '唐宋100指数报告-分品种'" />
											<img src="../../assets/images/index_fx.png" alt srcset
												v-else-if="item.sortName == '唐宋100指数（周）报告'" />
											<img src="../../assets/images/index_tejrb.png" alt srcset
												v-else-if="item.sortName == '唐尔街日报'" />
											<img src="../../assets/images/index_hysd.png" alt srcset
												v-else-if="item.sortName == '监测预警周报'" />
											<img src="../../assets/images/index_fx_pz.jpg" alt srcset v-else />
										</div>
										<p class="text-center">{{ item.reportTitle }}</p>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">

								<PriceIndexControl></PriceIndexControl>

								<!-- <div class="ad mw-modular-box" v-show="adIDsIndex[1] && adIDsIndex[1]['list'].length > 0">
                                    <a :href="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''" target="_blank">
                                        <img style="height: 80px;" :src="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" alt="" class="w100">
                                    </a>
                                </div>
                                <div class="ad mw-modular-box" v-show="adIDsIndex[1] && adIDsIndex[1]['list'].length > 1">
                                    <a :href="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 1 ? adIDsIndex[1]['list'][1]['adLink'] : '') : ''" target="_blank">
                                        <img style="height: 80px;" :src="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 1 ? adIDsIndex[1]['list'][1]['adPicturePath'] : '') : ''" alt="" class="w100">
                                    </a>
                                </div> -->
								<div v-if="adIDsIndex[8]['list']" style="margin-bottom: 20px; padding: 0 15px">
									<a v-for="(item, index) in adIDsIndex[8]['list']" :key="index" :href="item.adLink"
										target="_blank" class="w100 block"
										style="margin-top: 20px; margin-bottom: -10px;">
										<img :src="item.adPicturePath" alt="" class="w100">
									</a>
								</div>

								<FastNewsControl
									:ad="adIDsIndex[2] ? ( adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adPicturePath'] : '') : ''"
									:link="adIDsIndex[2] ? ( adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adLink'] : '') : ''">
								</FastNewsControl>

								<!-- <div class="ad" style="margin-top: 20px;" v-show="adIDsIndex[3] && adIDsIndex[3]['list'].length > 0">
                                    <a :href="adIDsIndex[3] ? ( adIDsIndex[3]['list'].length > 0 ? adIDsIndex[3]['list'][0]['adLink'] : '') : ''" target="_blank">
                                        <img style="height: 80px;" :src="adIDsIndex[3] ? ( adIDsIndex[3]['list'].length > 0 ? adIDsIndex[3]['list'][0]['adPicturePath'] : '') : ''" alt="" class="w100">
                                    </a>
                                </div> -->
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- 第五部分 end -->

				<div v-if="adIDsIndex[13]['list']">
					<a v-for="(item, index) in adIDsIndex[13]['list']" :key="index" :href="item.adLink" target="_blank"
						class="w100 block" style="margin-top: -10px; margin-bottom: -10px;">
						<img :src="item.adPicturePath" alt="" class="w100">
					</a>
				</div>

				<!-- 第六部分 start -->
				<div class="index-part-6 mw-modular-box bgWhite">
					<div class="swiper-container swiper-container-1">
						<div class="swiper-wrapper">
							<div class="swiper-slide" @click="goInforDetailPage(item)"
								v-for="(item, index) in inforFooterTable_list" :key="index">
								<div class="part-6-list inlineBlock vTop pointer">
									<img :src="'data:image/jpeg;base64,' + item.pic" alt="" srcset="">
									<div class="textCenter fontNormal bgGrey font14">{{ item.the_title }}</div>
								</div>
							</div>
						</div>
						<div class="swiper-button-next"></div>
						<div class="swiper-button-prev"></div>
					</div>
					<div style="height: 195px;" v-show="inforFooterTable_list.length == 0" class="textCenter font14">
						暂无相关资讯信息~</div>
				</div>
				<!-- 第六部分 end -->

				<!-- <a v-for="(item, index) in adIDsIndex[5]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin: -10px 0">
                    <img :src="item.adPicturePath" alt="" class="w100">
                </a> -->

				<!-- 合作伙伴部分 start -->
				<div class="index-part-7 bgWhite" style="margin-top: 20px;">
					<el-row style="padding: 5px 0;">
						<el-col :span="3">
							<div class="grid-content font16 fontNormal textCenter"
								style="line-height: 200px; border-right: 1px solid #ececec">合作伙伴</div>
						</el-col>
						<el-col :span="21">
							<div class="grid-content partner-list" style="line-height: 24px;">
								<a target="_blank" class="inlineBlock vTop">中国钢铁工业协会</a>
								<a target="_blank" class="inlineBlock vTop">全联冶金商会</a>
								<a target="_blank" class="inlineBlock vTop">中国炼焦行业协会</a>
								<a target="_blank" class="inlineBlock vTop">中国特钢企业协会</a>
								<a target="_blank" class="inlineBlock vTop" style="">中国金属材料流通协会</a>
								<a target="_blank" class="inlineBlock vTop">中国金属学会</a>
								<a target="_blank" class="inlineBlock vTop" style="">中国废钢铁应用协会</a>
								<a target="_blank" class="inlineBlock vTop" style=" margin-right: 0">中国钢铁工业协会钢管分会</a>
								<a target="_blank" class="inlineBlock vTop" style="">中国钢铁工业协会矿山分会</a>
								<a target="_blank" class="inlineBlock vTop" style="">中国特钢企业协会不锈钢分会</a>
								<a target="_blank" class="inlineBlock vTop" style="">中国耐火材料行业协会</a>
								<a target="_blank" class="inlineBlock vTop" style="">中国钢结构协会</a>
								<a target="_blank" class="inlineBlock vTop" style="">河北省冶金行业协会</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">山西省钢铁行业协会</a>
								<a target="_blank" class="inlineBlock vTop" style="">江苏省钢铁行业协会</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">天津钢铁工业协会</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 25px">河北钢铁集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">鞍钢集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">建龙集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">陕钢集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">南钢</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 8px">新天钢钢铁集团</a>
								<a target="_blank" class="inlineBlock vTop" style="">文安钢铁集团</a>
								<a target="_blank" href="http://www.hbjyjt.com/" class="inlineBlock vTop"
									style="">敬业集团</a>
								<a target="_blank" class="inlineBlock vTop" style="">津西钢铁集团</a>
								<a target="_blank" href="http://www.pygt.cn" class="inlineBlock vTop"
									style="">普阳钢铁集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 14px">镔鑫钢铁集团</a>
								<a target="_blank" class="inlineBlock vTop" style="">荣程集团</a>
								<a target="_blank" class="inlineBlock vTop" style="">宏兴钢铁</a>
								<a target="_blank" href="http://www.xinjin.cn" class="inlineBlock vTop"
									style="">新金钢铁</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 10px">文丰钢铁</a>
								<a target="_blank" href="http://www.delongsteel.com" class="inlineBlock vTop"
									style="margin-right: 10px">德龙钢铁</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 10px">建邦集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 10px">金鼎钢铁集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 0px">立恒钢铁集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 5px">唐山港集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 10px">松汀钢铁</a>
								<a target="_blank" href="http://www.xdgro.com" class="inlineBlock vTop"
									style="margin-right: 10px">鑫达钢铁</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 10px">旭阳集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 10px">天保集团</a>
								<a target="_blank" href="http://www.yfgg.com" class="inlineBlock vTop"
									style="margin-right: 12px">友发集团</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 0px">正大制管</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">天创管业</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 19px">神州通钢管</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">华洋钢管</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">杭州热联</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 20px">宝来工贸</a>
								<a target="_blank" class="inlineBlock vTop" style="margin-right: 0px">苏美达</a>
								<a target="_blank" class="inlineBlock vTop" style="">中建材</a>
								<a target="_blank" class="inlineBlock vTop" style="">永锋集团</a>
								<a target="_blank" class="inlineBlock vTop" style="">上海东证</a>
								<a target="_blank" class="inlineBlock vTop" style="">安泰</a>
								<a target="_blank" href="https://www.zlgx.com/" class="inlineBlock vTop"
									style="">中联钢信</a>
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- 合作伙伴部分 end -->
			</article>
		</div>
		<div class="popup-ad-dialog" v-if="getDay() > 0">
			<el-dialog :visible.sync='showPopupAd' :close-on-click-modal="false">
				<div class="popup-ad-box">
					<img class="popup-ad-day" :src="getImgSrc()"></img>
					<img class="popup-ad" src="../../assets/images/2023/popupAd.png"></img>
				</div>
			</el-dialog>
		</div>
		
		<div class="popup-ad-dialog" v-else>
			<el-dialog :visible.sync='showPopupAd' :close-on-click-modal="false">
				<div class="popup-ad-box">
					<img class="popup-ad" src="../../assets/images/2023/a18th/大促ing.png" @click="rightClick()"></img>
				</div>
			</el-dialog>
		</div>
		
		<!-- <div class="popup-ad-dialog-right">
			<div v-if="getDay() > 0" class="popup-ad-box" @click="rightClick()">
				<img class="popup-ad-day" :src="getImgSrc()"></img>
				<img class="popup-ad" src="../../assets/images/2023/popupAd.png"></img>
			</div>
			
			<div v-if="getDay() <= 0" class="popup-ad-box" @click="rightClick()">
				<img class="popup-ad" src="../../assets/images/2023/a18th/大促ing.png"></img>
			</div>

			<div v-if="getDay() == 0" class="popup-zp-box" @click="rightClick()">
				<img class="popup-zp1" src="../../assets/images/2023/circle2.png"></img>
				<img class="popup-zp2" src="../../assets/images/2023/button2.png"></img>
				<img class="popup-zp3" src="../../assets/images/2023/dizuo.png"></img>
			</div>
		</div> -->
		
		<Footer></Footer>
		<ConcatsControl></ConcatsControl>
		<!-- <CoupletsControl></CoupletsControl> -->
	</div>
</template>

<script>
	import '../../../node_modules/echarts/map/js/china.js'
	import Header from '../../templates/header'
	import Footer from '../../templates/footer'
	import ConcatsControl from '../../templates/concatsControl'
	import PriceIndexControl from '../../templates/priceIndexControl'
	import FastNewsControl from '../../templates/fastNewsControl'
	import CoupletsControl from '../../templates/coupletsControl'
	import {
		MapOption,
		LineOption
	} from '../../assets/js/options'
	import {
		baseUrl,
		reportClassify,
		getQueryString,
		adIDs
	} from '../../assets/js/common'
	import $ from 'jquery'
	import Swiper from 'swiper'
	import '../../assets/js/jquery.liMarquee.js'
	import moment from 'moment'

	var year = new Date().getFullYear()
	var month = new Date().getMonth() + 1
	if (month <= 9) {
		month = '0' + month
	}
	var day = new Date().getDate()

	if (day <= 9) {
		day = '0' + day
	}

	//闰2月
	if (month == '02' && day == '29') {
		day == '28'
	}

	var oneMonthAgo = new Date()
	oneMonthAgo.setDate(oneMonthAgo.getDate() - 30)
	var startYear = oneMonthAgo.getFullYear()
	var startMonth = oneMonthAgo.getMonth() + 1
	if (startMonth <= 9) {
		startMonth = '0' + startMonth
	}
	var startDay = oneMonthAgo.getDate()
	if (startDay <= 9) {
		startDay = '0' + startDay
	}
	var startDate = startYear + '-' + startMonth + '-' + startDay
	var endDate = year + '-' + month + '-' + day

	export default {
		name: 'Index',
		components: {
			Header,
			Footer,
			ConcatsControl,
			PriceIndexControl,
			FastNewsControl,
			CoupletsControl
		},
		data() {
			return {
				showPopupAd: false,
				showPopupZP: false,
				showTitle: true,
				priceVisiable: false,
				priceDates: [startDate, endDate],
				priceDatas: [],
				priceNCode: '',
				priceNCodeIndex: 0,
				priceNCodeName: '',
				priceNCodeYearData: [],
				priceNCodeMonthData: [],
				priceNCodeDayDataAll: [],
				priceNCodeDayDataPage: [],
				priceNCodeCurrent: 1,
				priceNCodePageSize: 15,
				priceNCodeTotal: 0,
				priceNCodeTabIndex: 0,
				token_cyw: '',
				navigationId: '',
				submenu_list_1: [], // 根据一级菜单分类获取的所有二级菜单存储在这
				consult_sel_all_center: [],
				consult_sel_all: [], // 全部新闻 - 行业热点
				ads: {
					'name1': []
				},

				inforTab_list: [],
				inforTable_list: [],
				inforTable_list2: [],
				inforTabName: '0',

				inforFooterTable_list: [],
				inforFooterTable_list2: [],

				navigations_list: {}, // 一级菜单
				navigations_visit: {}, // 判断当前点击是否为登录后才能点
				submenu_list: {
					pz: [],
					zx: [],
					yb: [],
					zs: [],
					zh: []
				}, // 二级菜单
				searchReport_list: [], // 研报最新
				searchFourReport_list: [],
				reportClassify: reportClassify,

				basePrice_list: [], // 基准价
				basePrice_list1: [],
				basePriceTable_list: [],
				basePriceTable_title: '',
				basePriceProduct_list: [],
				basePriceProduct_id: '',
				basePriceTab: '',

				adIDsIndex: [{
					name: 'indexSwiper',
					id: adIDs['indexSwiper'],
					list: []
				}, {
					name: 'B',
					id: adIDs['B'],
					list: []
				}, {
					name: 'C',
					id: adIDs['C'],
					list: []
				}, {
					name: 'D',
					id: adIDs['D'],
					list: []
				}, {
					name: 'E',
					id: adIDs['E'],
					list: []
				}, {
					name: 'F',
					id: adIDs['F'],
					list: []
				}, {
					name: 'indexRow',
					id: adIDs['indexRow'],
					list: []
				}, {
					name: 'index38',
					id: adIDs['index38'],
					list: []
				}, {
					name: 'index47',
					id: adIDs['index47'],
					list: []
				}, {
					name: 'index51',
					id: adIDs['index51'],
					list: []
				}, {
					name: 'index52',
					id: adIDs['index52'],
					list: []
				}, {
					name: 'index53',
					id: adIDs['index53'],
					list: []
				}, {
					name: 'index60',
					id: adIDs['index60'],
					list: []
				}, {
					name: 'index62',
					id: adIDs['index62'],
					list: []
				}],
				tjloading: true, //zhangziao
				tj_list: [], //zhangziao
				mapLoading: false,
				priceIndexJN: {},
				priceIndexGP: {},
				priceIndexDG: {},
				priceIndexJKK: {},

				// 新增企业报价
				varietiesType: '',
				varietiesList: [],
				varTableList: [],
				varIsNone: false,
				liMarquee: null,
				showFloatAd: false,

				// 新增视频模块
				videoListTop: [],
				videoList: [],
				videoType: [],
				videoTypeId: '',
				jiage_count: "40", //品种+价格
				clickjiage: "0", //价格编号
				selectjiage: "4", //品种编号
				jiage_tableData: [],
				cblr_tableData: [],
				clickgongying1: "0",
				cn_lwg_tableData: [],
				gs_lwg_tableData: [],
				clickgongying2: "0",
				cn_xc_tableData: [],
				gs_xc_tableData: [],
				clickgongying3: "0",
				cn_bc_tableData: [],
				gs_bc_tableData: [],
				clickgongying4: "0",
				cn_dg_tableData: [],
				gs_dg_tableData: [],
				clickgongying5: "0",
				cn_xg_tableData: [],
				gs_xg_tableData: [],
				clickgongying6: "0",
				cn_gc_tableData: [],
				clickgongying7: "0",
				cn_gp_tableData: [],
				gs_gp_tableData: [],
				rj_gp_tableData: [],
				clickgongying8: "0",
				cn_mj_tableData: [],
				gs_mj_tableData: [],
				clickgongying9: "0",
				cn_tks_tableData: []
			}
		},
		mounted() {
			// 初始化内容

			// 获取页面宽度
			setTimeout(() => {
				var windowWidth = $(window).width();
				if (windowWidth < 1366) {
					$('.download-entry').css({
						'right': '20px'
					})
					$('.download-entry-left').css({
						'left': '20px'
					})
				} else {
					var posLeft = ((windowWidth - 1200) / 2) - 140;
					if (posLeft < 20) {
						posLeft = 20;
					}
					$('.download-entry').css({
						'right': posLeft + 'px'
					})
					$('.download-entry-left').css({
						'left': posLeft + 'px'
					})

				}
				this.showFloatAd = true;
			}, 8000)
			
			window.addEventListener('message', (e) => {
			    if(e.data.type == 'closeDialog') {
					this.showPopupZP = false
				}
			})
			
			this.navigationId = this.$route.params.id;
			this.token_cyw = this.$cookies.get('token_cyw');
			this.findNaTree();
			this.tNewsConsultSelAll();
			this.getNavigationLevel1();
			this.submenuInit();
			this.listInit();
			this.getAdByAdp();
			this.findAllVarieties();
			this.setMarginTop();
			this.findAllVideoType();
			this.getMsgInfo();
			this.getPriceDatas();
			var self = this; //新增价格，成本利润，供应板块
			setTimeout(function() {
				self.getJiageList();
				self.getCblrList();
				self.getGongyingList1();
				self.getGongyingList2();
				self.getGongyingList3();
				self.getGongyingList4();
				self.getGongyingList5();
				self.getGongyingList6();
				self.getGongyingList7();
				self.getGongyingList8();
				self.getGongyingList9();
			}, 4000);
		},
		methods: {
			getDay() {
				const endDate = new Date('2023-08-09 00:00:00').valueOf()
				var d = new Date().valueOf()
				var day = Math.floor((endDate - d) / (24 * 60 * 60 * 1000))
				return day
			},
			getImgSrc() {
				if(this.getDay() > 0) {
					return require(`../../assets/images/2023/popupAd-day${this.getDay()}.png`)
				} else {
					return require(`../../assets/images/2023/popupAd-day0.png`)
				}
			},
			rightClick() {
				if(this.getDay() > 0) {
					this.showPopupAd = true
				} else {
					let router = this.$router.resolve({
						path: `../activity18th?show=true`
					})
					debugger
					window.open(router.href, '_blank')
				}
			},
			getPriceDatas() {
				var self = this;
				$.ajax({
					url: 'https://service.chinatsi.net/api_v3/cye_index',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 'ok') {
							let priceDatas = []
							let priceDataZS = []
							for (let i = 0; i < res.data.length; i++) {
								if (i == 2 || i == 3 || i == 4) {
									priceDataZS.push(res.data[i])
								} else {
									priceDatas.push(res.data[i])
								}
							}
							console.log('---')
							priceDatas.splice(2, 0, priceDataZS)
							self.priceDatas = priceDatas
							console.log(self.priceDatas)
						}
					},
					error: () => {}
				})
			},
			getDetailPriceData(index, ncode, name) {
				var self = this;
				self.priceVisiable = true
				self.priceNCodeIndex = index
				self.priceNCodeName = name
				self.priceNCode = ncode
				self.priceNCodeCurrent = 1

				self.priceNCodeDayDataAll = []
				self.priceNCodeDayDataPage = []
				self.priceNCodeTotal = 0
				self.priceNCodeMonthData = []
				self.priceNCodeYearData = []

				let sDate = new moment(self.priceDates[0]).format('yyyy-MM-DD')
				let eDate = new moment(self.priceDates[1]).format('yyyy-MM-DD')

				//日
				let url_day =
					`https://service.chinatsi.net/api_v3/cye?sdate=${sDate}&edate=${eDate}&n_code=${ncode}&level=date`
				//月
				let url_month =
					`https://service.chinatsi.net/api_v3/cye?sdate=1999-01-01&edate=2200-12-30&n_code=${ncode}&level=month`
				//年
				let url_year =
					`https://service.chinatsi.net/api_v3/cye?sdate=1999-01-01&edate=2200-12-30&n_code=${ncode}&level=year`

				$.ajax({
					url: url_day,
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 'ok') {
							self.priceNCodeDayDataAll = res.data
							self.priceNCodeDayDataPage = self.priceNCodeDayDataAll.slice((self
									.priceNCodeCurrent - 1) * self.priceNCodePageSize, self
								.priceNCodeCurrent * self.priceNCodePageSize)
							self.priceNCodeTotal = self.priceNCodeDayDataAll.length
						}
					},
					error: (e) => {
						console.log(e)
					}
				})

				$.ajax({
					url: url_month,
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 'ok') {
							self.priceNCodeMonthData = res.data.reverse()
						}
					},
					error: () => {}
				})

				$.ajax({
					url: url_year,
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 'ok') {
							self.priceNCodeYearData = res.data.reverse()
						}
					},
					error: () => {}
				})
			},
			priceTabChange(index) {
				var self = this
				self.priceNCodeTabIndex = index
				self.getDetailPriceData(2, self.priceDatas[2][index].n_code, self.priceDatas[2][index].name)
			},
			priceCurrentChange(current) {
				var self = this
				self.priceNCodeCurrent = current
				self.priceNCodeDayDataPage = self.priceNCodeDayDataAll.slice((self.priceNCodeCurrent - 1) * self
					.priceNCodePageSize, self.priceNCodeCurrent * self.priceNCodePageSize)
			},
			handleClickGongying1(params) {
				this.clickgongying1 = params.target.dataset.index;
			},
			handleClickGongying2(params) {
				this.clickgongying2 = params.target.dataset.index;
			},
			handleClickGongying3(params) {
				this.clickgongying3 = params.target.dataset.index;
			},
			handleClickGongying4(params) {
				this.clickgongying4 = params.target.dataset.index;
			},
			handleClickGongying5(params) {
				this.clickgongying5 = params.target.dataset.index;
			},
			handleClickGongying6(params) {
				this.clickgongying6 = params.target.dataset.index;
			},
			handleClickGongying7(params) {
				this.clickgongying7 = params.target.dataset.index;
			},
			handleClickGongying8(params) {
				this.clickgongying8 = params.target.dataset.index;
			},
			handleClickGongying9(params) {
				this.clickgongying9 = params.target.dataset.index;
			},
			checkGongYing(str) {
				if (str.indexOf("东北") >= 0 || str.indexOf("西北") >= 0 || str.indexOf("中南") >= 0 || str.indexOf("西南") >= 0 ||
					str.indexOf("华北") >= 0 || str.indexOf("华东") >= 0 || str.indexOf("唐山") >= 0 || str.indexOf("全国") >= 0) {
					if (str.indexOf("窄带") < 0) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			},
			getGongyingList1() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/screwIndexData/indexDatas?cpage=1&pageSize=20&nodeId=0301',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_lwg_tableData = [];
							self.gs_lwg_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								if (self.checkGongYing(res.data[i].nodeName)) {
									if (res.data[i].nodeName.indexOf("产能") >= 0) {
										self.cn_lwg_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("条数") >= 0) {
										self.gs_lwg_tableData.push(res.data[i]);
									}
								}
							}

						}
					},
					error: () => {}
				})
			},
			getGongyingList2() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/wirerodDataN/indexDatas?cpage=1&pageSize=20&nodeId=0201',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_bc_tableData = [];
							self.gs_bc_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								if (self.checkGongYing(res.data[i].nodeName)) {
									if (res.data[i].nodeName.indexOf("产能") >= 0) {
										self.cn_bc_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("条数") >= 0) {
										self.gs_bc_tableData.push(res.data[i]);
									}
								}
							}
						}
					},
					error: () => {}
				})
			},
			getGongyingList3() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/plateDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_xc_tableData = [];
							self.gs_xc_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								if (self.checkGongYing(res.data[i].nodeName)) {
									if (res.data[i].nodeName.indexOf("产能") >= 0) {
										self.cn_xc_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("条数") >= 0) {
										self.gs_xc_tableData.push(res.data[i]);
									}
								}
							}

						}
					},
					error: () => {}
				})
			},
			getGongyingList4() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/indexData/indexDatas?cpage=1&pageSize=40&nodeId=0101',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_dg_tableData = [];
							self.gs_dg_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								if (self.checkGongYing(res.data[i].nodeName)) {
									if (res.data[i].nodeName.indexOf("产能") >= 0) {
										self.cn_dg_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("条数") >= 0) {
										self.gs_dg_tableData.push(res.data[i]);
									}
								}
							}

						}
					},
					error: () => {}
				})
			},
			getGongyingList5() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/sectionDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_xg_tableData = [];
							self.gs_xg_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								if (self.checkGongYing(res.data[i].nodeName)) {
									if (res.data[i].nodeName.indexOf("产能") >= 0) {
										self.cn_xg_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("条数") >= 0) {
										self.gs_xg_tableData.push(res.data[i]);
									}
								}
							}

						}
					},
					error: () => {}
				})
			},
			getGongyingList6() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/pipeDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_gc_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								self.cn_gc_tableData.push(res.data[i]);
							}

						}
					},
					error: () => {}
				})
			},
			getGongyingList7() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/pageIronDataN/indexDatas?cpage=1&pageSize=50&nodeId=0101',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_gp_tableData = [];
							self.gs_gp_tableData = [];
							self.rj_gp_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								if (self.checkGongYing(res.data[i].nodeName)) {
									if (res.data[i].nodeName.indexOf("产能") >= 0) {
										self.cn_gp_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("个数") >= 0) {
										self.gs_gp_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("容积") >= 0) {
										self.rj_gp_tableData.push(res.data[i]);
									}
								}
							}

						}
					},
					error: () => {}
				})
			},
			getGongyingList8() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/cokeDataN/indexDatas?cpage=1&pageSize=20&nodeId=0201',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.cn_mj_tableData = [];
							self.gs_mj_tableData = [];
							for (var i = 0; i < res.data.length; i++) {
								if (self.checkGongYing(res.data[i].nodeName)) {
									if (res.data[i].nodeName.indexOf("产能") >= 0) {
										self.cn_mj_tableData.push(res.data[i]);
									}
									if (res.data[i].nodeName.indexOf("个数") >= 0) {
										self.gs_mj_tableData.push(res.data[i]);
									}
								}
							}

						}
					},
					error: () => {}
				})
			},
			getGongyingList9() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/ironOreIndexData/indexDatas?cpage=1&pageSize=20&nodeId=0101',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							var temparr = [];
							for (var i = 0; i < res.data.length; i++) {
								var obj = res.data[i];
								obj["data"] = parseFloat(res.data[i].data).toFixed(2);
								temparr.push(obj);
							}
							self.cn_tks_tableData = temparr;
						}
					},
					error: () => {}
				})
			},
			handleClickJiage(params) {
				this.clickjiage = params.target.dataset.index;
				this.jiage_count = this.selectjiage + this.clickjiage;
				this.getJiageList();
			},
			handleSelectJiage(key, keyPath) {
				this.selectjiage = key;
				if (key == "1" || key == "2") {
					this.clickjiage = "1";
				} else {
					this.clickjiage = "0";
				}
				this.jiage_count = this.selectjiage + this.clickjiage;
				this.getJiageList();
			},
			goAllPrice() {
				let routeData = this.$router.resolve({
					path: `/home/allPrice?tag=A_0`
				});
				window.open(routeData.href, '_blank');
			},
			getJiageList() {
				console.log(this.jiage_count);
				var self = this;
				var myDate2 = new Date();
				var eyear = myDate2.getFullYear();
				var emonth = myDate2.getMonth() + 1;
				emonth = (emonth < 10 ? "0" + emonth : emonth);
				var eday = myDate2.getDate();
				eday = (eday < 10 ? "0" + eday : eday);
				var edate = eyear + "-" + emonth + "-" + eday;
				var btime = new Date().getTime();
				var myDate1 = new Date(btime - 1123200000); //前14天
				var byear = myDate1.getFullYear();
				var bmonth = myDate1.getMonth() + 1;
				bmonth = (bmonth < 10 ? "0" + bmonth : bmonth);
				var bday = myDate1.getDate();
				bday = (bday < 10 ? "0" + bday : bday);
				var bdate = byear + "-" + bmonth + "-" + bday;

				var url = "";
				var pagenum = 15;
				if (this.jiage_count == "00") {
					url =
						"http://118.126.142.187:8088/online/domesticMarketPrice/selectDomesticMarketPriceList?cpage=1&pageSize=" +
						pagenum + "&marketId=&originId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&productId=&standard=&enterpriseId=&priceFormId=";
				}
				if (this.jiage_count == "10") {
					url = "";
				}
				if (this.jiage_count == "20") {
					url = "";
				}
				if (this.jiage_count == "30") {
					url = "http://118.126.142.187:8088/online/scrapMarket/MarketList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&productId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=&enterpriseId=&type=3&nodeId=0101";
				}
				if (this.jiage_count == "40") {
					url = "http://118.126.142.187:8088/online/screwMarket/screwMarketList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=&productId=&enterpriseId=";
				}
				if (this.jiage_count == "50") {
					url = "http://118.126.142.187:8088/online/wirerodMarket/wirerodMarketList?cpage=1&pageSize=" +
						pagenum + "&marketId=&originId=&productId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=&enterpriseId=";
				}
				if (this.jiage_count == "60") {
					url = "http://118.126.142.187:8088/online/paletMarket/plateMarketList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&productId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=&enterpriseId=";
				}
				if (this.jiage_count == "70") {
					url = "http://118.126.142.187:8088/online/marketprice/marketPrices?cpage=1&pageSize=" + pagenum +
						"&productId=&marketId=&originId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceForm=&enterpriseId=";
				}
				if (this.jiage_count == "80") {
					url = "http://118.126.142.187:8088/online/sectionMarket/sectionMarketList?cpage=1&pageSize=" +
						pagenum + "&marketId=&originId=&productId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=&enterpriseId=";
				}
				if (this.jiage_count == "90") {
					url = "http://118.126.142.187:8088/online/pipeMarket/MarketList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&productId=&type=1&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=&enterpriseId=";
				}
				if (this.jiage_count == "01") {
					url = "";
				}
				if (this.jiage_count == "11") {
					url = "http://118.126.142.187:8088/online/cokeExFactory/ExFactoryList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&productId=&enterpriseId=&type=1&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&standard=&priceFormId=";
				}
				if (this.jiage_count == "21") {
					url = "http://118.126.142.187:8088/online/billetExFactory/exFactoryList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&productId=&enterpriseId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=";
				}
				if (this.jiage_count == "31") {
					url = "";
				}
				if (this.jiage_count == "41") {
					url = "http://118.126.142.187:8088/online/screwExFactory/exFactoryList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&enterpriseId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=&productId=";
				}
				if (this.jiage_count == "51") {
					url = "http://118.126.142.187:8088/online/wirerodExFactory/exFactoryList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&productId=&enterpriseId=&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=";
				}
				if (this.jiage_count == "61") {
					url = "";
				}
				if (this.jiage_count == "71") {
					url = "http://118.126.142.187:8088/online/exprice/exprices?cpage=1&pageSize=" + pagenum +
						"&productId=&marketId=&originId=&standard=&texture=&enterpriseId=&beginDate=" + bdate +
						"&endDate=" + edate + "&priceFormId=&rq=";
				}
				if (this.jiage_count == "81") {
					url = "http://118.126.142.187:8088/online/sectionExFactory/exFactoryList?isprice=N&cpage=1&pageSize=" +
						pagenum + "&marketId=&originId=&productId=&enterpriseId=&beginDate=" + bdate + "&endDate=" +
						edate + "&rq=&texture=&standard=&priceFormId=";
				}
				if (this.jiage_count == "91") {
					url = "http://118.126.142.187:8088/online/pipeExFactory/exFactoryList?cpage=1&pageSize=" + pagenum +
						"&marketId=&originId=&productId=&enterpriseId=&type=1&beginDate=" + bdate + "&endDate=" + edate +
						"&rq=&texture=&standard=&priceFormId=";
				}
				$.ajax({
					url: url,
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							self.jiage_tableData = res.data;
						}
					},
					error: () => {}
				})
			},
			getCblrList() {
				var self = this;
				$.ajax({
					url: 'http://118.126.142.187:8088/online/industryData/indexDataList?nodeId=0901',
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 0) {
							var tempdata = res.data;
							$.ajax({
								url: 'http://118.126.142.187:8088/online/industryData/indexDatas?nodeId=0901',
								type: 'get',
								dataType: 'json',
								success: (res) => {
									if (res.code == 0) {
										var tempcb = [];
										for (var i = 0; i < res.data.length; i++) {
											for (var j = 0; j < tempdata.length; j++) {
												if (res.data[i].nCode == tempdata[j].N_CODE) {
													tempcb.push({
														"code": "",
														"mc": res.data[i].nName.replace(
															"制造成本（元/吨）", ""),
														"cb": tempdata[j].DATA,
														"lr": "",
														"rq": tempdata[j].RQ
													});
													break;
												}
											}
										}
										$.ajax({
											url: 'http://118.126.142.187:8088/online/industryData/indexDatas?nodeId=0902',
											type: 'get',
											dataType: 'json',
											success: (res) => {
												if (res.code == 0) {
													for (var i = 0; i < tempcb
														.length; i++) {
														for (var j = 0; j < res.data
															.length; j++) {
															if (tempcb[i].mc == res
																.data[j].nName.replace(
																	"利润（元/吨）", "")) {
																tempcb[i].code = res
																	.data[j].nCode;
															}
														}
													}
													$.ajax({
														url: 'http://118.126.142.187:8088/online/industryData/indexDataList?nodeId=0902',
														type: 'get',
														dataType: 'json',
														success: (res) => {
															if (res.code ==
																0) {
																console
																	.log(
																		tempcb
																	);
																for (var i =
																		0; i <
																	tempcb
																	.length; i++
																) {
																	for (
																		var j =
																			0; j <
																		res
																		.data
																		.length; j++
																	) {
																		if (tempcb[
																				i
																			]
																			.code ==
																			res
																			.data[
																				j
																			]
																			.N_CODE
																		) {
																			tempcb
																				[
																					i
																					]
																				.lr =
																				res
																				.data[
																					j
																				]
																				.DATA;
																			break;
																		}
																	}
																}
																self.cblr_tableData =
																	tempcb;
															}
														},
														error: () => {}
													})
												}
											},
											error: () => {}
										})
									}
								},
								error: () => {}
							})
						}
					},
					error: () => {}
				})
			},
			//点击基准价tab zhangziao
			handleClickChangeTab(tab, event) {
				console.log(tab.name);
				this.changeMapClassify(tab.name);
			},
			//滚动调价列表zhangziao
			getMsgInfo() {
				const self = this;
				self.tjloading = true;
				let sdate = '';
				let edate = '';
				$.ajax({
					url: `${baseUrl.modify}/API_V1/API_MSGBYMSSQL/MSG_INFO?keyword=${'调价:%25'}&sdate=${''}&edate=${''}&pz=${''}&pagenum=1&pernum=100`,
					data: {},
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 'ok') {
							self.tj_list = [];
							if (res.data.length > 0) {
								let arr = [];
								let dateArr = [];
								res.data.forEach((item, index) => {
									if (index == 0) {
										dateArr.push(item.sdate.substr(0, 10));
									} else {
										const j = dateArr.length - 1;
										if (item.sdate.substr(0, 10) != dateArr[j]) {
											dateArr.push(item.sdate.substr(0, 10));
										}
									}
								})
								dateArr.forEach((item, index) => {
									let obj = {
										sdate: '',
										date: item,
										week: '', // self.getWeek(item),
										list: []
									}
									res.data.forEach((cItem, cIndex) => {
										if (cItem.sdate.substr(0, 10) == item) {
											obj.sdate = cItem.sdate;
											cItem.time = cItem.sdate.substr(11, 5);
											obj.list.push(cItem);
										}
									})
									arr.push(obj);
								})
								self.tj_list = arr;
								$('.index-quote-list-box2').liMarquee({
									direction: 'left',
									//circular:true,
									//loop: -1,
									scrollamount: 50,
									hoverstop: true
								});
							}
							self.tjloading = false;
						} else {
							$('.index-quote-list-box2').liMarquee('destroy');
							self.$message.error(res.message);
							self.tjloading = false;
						}
					},
					error: () => {
						self.$message.error('未获取到调价信息')
						self.tjloading = false;
					}
				})
			},
			setMarginTop: function() {
				var height = $('.year-header img').height();
				$('#marginTop').css('padding-top', height + 40);
			},

			// 获取广告信息
			getAdByAdp() {
				const self = this;
				// self.adIDsIndex = ;
				self.adIDsIndex.forEach((item, index) => {
					self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
						if (res.code == 0) {
							self.adIDsIndex[index]['list'] = res.data;
							if (index == 0) {
								const height = $(window).height();
								$('#adSlideImg').height(height - 105)
								setTimeout(() => {
									self.ADSlideToggle();
								}, 3000)
							}
						}
					})
				})
			},
			// 广告下滑特效
			ADSlideToggle() {
				const height = $(window).height();
				const imgWidth = (height - 103) * 2.5;
				/*
				$('#adSlideImg').css({
					'margin-left': ('-' + (imgWidth - 1200) / 2 + 'px'),
					'width': imgWidth
				});

				$('#slideAD').animate({
					'height': height - 103
				}, 2000, () => {
					setTimeout(() => {
						$('#slideAD').animate({
							'height': '0px'
						}, 2000, () => {
							$('#adSlideBox').animate({
								'opacity': '1',
								'top': '90%'
							}, 2000, () => {})
						});
					}, 3000)
				})
				*/
			},

			// 获取广告信息 end

			/* **********20210728新增视频模块 */

			findAllVideoType() {
				const self = this;
				self.$get(`${baseUrl.online}/videoType//findAllType?status=Y`, {}).then(res => {
					if (res.code == 0) {
						self.videoType = res.data;
						if (res.data.length > 0) {
							self.videoTypeId = res.data[0]['typeId'];
							self.getVideoListById(self.videoTypeId);
						}
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到分类信息')
				})
			},
			getVideoListById(typeId) {
				const self = this;
				self.$post(`${baseUrl.online}/videoInfor/frontVideoList/1/7`, {
					typeId: typeId
				}).then(res => {
					if (res.code == 0) {
						if (res.data.length > 0) {
							self.videoListTop[0] = res.data[0];
							if (res.data.length > 1) {
								self.videoList = res.data.slice(1, res.data.length);
							}
						} else {
							self.videoListTop = [];
							self.videoList = [];
						}

					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到快讯信息');
				})
			},
			changeVideoType(typeId) {
				const _typeId = typeId;
				this.videoTypeId = _typeId;
				this.getVideoListById(_typeId);
			},
			goVideoPage(typeId) {
				// this.$router.push(`/home/video?id=${typeId}`)
				let routeData = this.$router.resolve({
					path: `/home/video?id=${typeId}`
				});
				window.open(routeData.href, '_blank');
			},

			/* **********20210728新增视频模块 */


			/****** 根据一级菜单id获取二级菜单 start ************************************************************/
			findNaTree() {
				const self = this;
				let url = ``;
				if (self.token_cyw) {
					self.$get(`${baseUrl.business}/api/user/userByToken/${self.token_cyw}`, {}).then(res_1 => {
						if (res_1.status == 200) {
							url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=Y`;
						} else {
							url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
						}
						self.$get(url, {}).then(res => {
							if (res.code == 0) {
								self.submenu_list_1 = [];
								res.data.forEach((item, index) => {
									self.navigations_visit[item.navigationName] = item.visitLimit;
									if (item.navigationName == '首页') {
										self.submenu_list_1 = item.childs;
									}
								})
								////////////////
								self.submenu_list_1.forEach((item, index) => {
									if (item.navigationName == '品种') {
										item.childs.forEach((item2, index2) => {
											if (item2.navigationName == "螺纹钢") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_0";
											}
											if (item2.navigationName == "线材") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_1";
											}
											if (item2.navigationName == "带钢") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_2";
											}
											if (item2.navigationName == "板材") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_3";
											}
											if (item2.navigationName == "型钢") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_4";
											}
											if (item2.navigationName == "管材") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_5";
											}
											if (item2.navigationName == "废钢") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_6";
											}
											if (item2.navigationName == "钢坯") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_7";
											}
											if (item2.navigationName == "国产矿") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_8";
											}
											if (item2.navigationName == "进口矿") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_9";
											}
											if (item2.navigationName == "煤炭") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_10";
											}
											if (item2.navigationName == "焦炭") {
												item2.navigationUrl =
													"/home/allPrice?tag=A_11";
											}
										})
									}
									if (item.navigationName == '数据') {
										item.childs.forEach((item2, index2) => {
											item2.navigationUrl = 'https://vote.chinatsi.net/datamarket/';
										})
									}
								})
								console.log(self.submenu_list_1);
							} else {
								self.$message.error(res.message);
							}
						}).catch(err => {
							// self.$message.error('未获取到二级菜单信息');
						})
					})
				} else {
					url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
					self.$get(url, {}).then(res => {
						if (res.code == 0) {
							self.submenu_list_1 = [];
							res.data.forEach((item, index) => {
								self.navigations_visit[item.navigationName] = item.visitLimit;
								if (item.navigationName == '首页') {
									self.submenu_list_1 = item.childs;
								}
							})
							////////////////
							self.submenu_list_1.forEach((item, index) => {
								if (item.navigationName == '品种') {
									item.childs.forEach((item2, index2) => {
										if (item2.navigationName == "螺纹钢") {
											item2.navigationUrl = "/home/allPrice?tag=A_0";
										}
										if (item2.navigationName == "线材") {
											item2.navigationUrl = "/home/allPrice?tag=A_1";
										}
										if (item2.navigationName == "带钢") {
											item2.navigationUrl = "/home/allPrice?tag=A_2";
										}
										if (item2.navigationName == "板材") {
											item2.navigationUrl = "/home/allPrice?tag=A_3";
										}
										if (item2.navigationName == "型钢") {
											item2.navigationUrl = "/home/allPrice?tag=A_4";
										}
										if (item2.navigationName == "管材") {
											item2.navigationUrl = "/home/allPrice?tag=A_5";
										}
										if (item2.navigationName == "废钢") {
											item2.navigationUrl = "/home/allPrice?tag=A_6";
										}
										if (item2.navigationName == "钢坯") {
											item2.navigationUrl = "/home/allPrice?tag=A_7";
										}
										if (item2.navigationName == "国产矿") {
											item2.navigationUrl = "/home/allPrice?tag=A_8";
										}
										if (item2.navigationName == "进口矿") {
											item2.navigationUrl = "/home/allPrice?tag=A_9";
										}
										if (item2.navigationName == "煤炭") {
											item2.navigationUrl = "/home/allPrice?tag=A_10";
										}
										if (item2.navigationName == "焦炭") {
											item2.navigationUrl = "/home/allPrice?tag=A_11";
										}
									})
								}
								if (item.navigationName == '数据') {
									item.childs.forEach((item2, index2) => {
										item2.navigationUrl = 'https://vote.chinatsi.net/datamarket/';
									})
								}
							})
							console.log(self.submenu_list_1);
						} else {
							self.$message.error(res.message);
						}
					}).catch(err => {
						// self.$message.error('未获取到二级菜单信息');
					})
				}
			},
			/****** 根据一级菜单id获取二级菜单 end **************************************************************/

			/****** 行业热点导航（取资讯内容） start ************************************************************/

			tNewsConsultSelAll() {
				const self = this;
				const date = new Date();
				const edate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
				$.ajax({
					url: `${baseUrl.service}/api_v3/t_news_consult_fuzzy`,
					data: {
						type_name: '',
						big_type: '',
						alias_cn_name: '',
						the_title: '',
						pagenum: 1,
						pernum: 8,
					},
					type: 'get',
					dataType: 'json',
					success: (res) => {
						const length = res.data.length > 7 ? 7 : res.data.length - 1;
						const datas = $.extend(true, [], res.data);
						self.consult_sel_all_center = res.data.splice(0, 2);
						self.consult_sel_all = datas.splice(2, length);
					},
					error: () => {
						// self.$message.error('未获取到资讯信息')
					}
				})
			},

			/****** 行业热点导航（取资讯内容） end **************************************************************/

			/* ***** 获取全部1级菜单，用于匹配页面跳转 start ********** */
			getNavigationLevel1() {
				const self = this;
				self.$get(`${baseUrl.cyw}/navigation/selectNa?level=1`, {}).then(res => {
					if (res.code == '0') {
						res.data.forEach((item, index) => {
							self.navigations_list[item.navigationName] =
								`${item.navigationUrl}/${item.navigationId}`;
						})
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					/*  self.$message.error('获取导航信息失败');  */
				})
			},
			/* ***** 获取全部1级菜单，用于匹配页面跳转 start ********** */


			/* ***** 二级菜单数据 start ***************************** */
			submenuInit() {
				var self = this;
				this.findAllProductTag();
				this.findReportSort();
				this.findNewsClassify();
				setTimeout(function() { //基准价地图初始化不显示，延迟两秒调
					self.findIndexTopList();
				}, 2000);
				this.getNewsEveryDay();
			},

			// 品种部分，取基准价 大产品分类
			findAllProductTag() {
				const self = this;
				self.$get(`${baseUrl.online}/industriaBasePrise/findAllProductTag`, {}).then(res => {
					if (res.code == 0) {
						self.submenu_list['pz'] = res.data;
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到分类信息')
				})
			},
			// 研报 /industria/reportSort/findReportSortByUserFormat
			findReportSort() {
				const self = this;
				self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
					if (res.code == 0) {
						self.submenu_list['yb'] = res.data;
						res.data.forEach((item, index) => {
							self.searchReport(item.sortId, item.sortName)
						})
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到分类信息')
				})
			},

			// 资讯分类
			findNewsClassify() {
				const self = this;
				$.ajax({
					url: `${baseUrl.service}/api_v3/news_classify?pagenum=1&pernum=99`,
					data: {},
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if (res.code == 'ok') {
							self.submenu_list['zx'] = [];
							self.inforTab_list = [];
							res.data.forEach((item, index) => {
								if (item.the_level == 1 && item.is_valid == 'Y') {
									self.submenu_list['zx'].push(item);
									self.inforTab_list.push(item);
								}
							})
							self.tNewsConsultSel();
						} else {
							self.$message.error(res.message);
						}
					},
					error: () => {
						// self.$message.error('未获取到资讯分类信息')
					}
				})
			},

			// 价格指数滚动
			// 获取每日钢坯最新数据
			getNewsEveryDay() {
				const self = this;
				self.$get(`${baseUrl.online}/industria/billetDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101`, {}).then(
					res => {
						if (res.code == 0) {
							$.each(res.data, (index, item) => {
								if (item.nCode == 'pricnonobitcchnokrts') {
									self.priceIndexGP = item;
								}

							})
							self.getDGNewsEveryDay();
						} else {
							self.$message.error(res.message)
						}
					})
			},
			// 获取每日带钢最新数据
			getDGNewsEveryDay() {
				const self = this;
				self.$get(`${baseUrl.online}/indexData/indexDatas?cpage=1&pageSize=20&nodeId=0401`, {}).then(res => {
					if (res.code == 0) {
						$.each(res.data, (index, item) => {
							if (item.nCode == 'pricnonohstcchnokrts') {
								self.priceIndexDG = item;
							}
						})
						self.getIronNewsEveryDay();
					} else {
						self.$message.error(res.message)
					}
				})
			},
			// 获取进口矿每日最新数据
			getIronNewsEveryDay() {
				const self = this;
				self.$get(`${baseUrl.online}/industria/ironOreIndexData/newIndexDatas?cpage=1&pageSize=20&nodeId=0301`, {})
					.then(res => {
						if (res.code == 0) {
							res.data.forEach((item, index) => {
								if (item.nodeName == '62%粉矿') {
									self.priceIndexJKK = item;
									return;
								}
							})
							self.getJNNewsEveryDay()
						} else {
							self.$message.error(res.message)
						}
					})
			},
			// 获取晋南钢铁（高线）每日数据
			getJNNewsEveryDay() {
				const self = this;
				const date = new Date();
				const beginDate =
					`${(date.getFullYear() - 1)}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : ('0' + (date.getMonth() + 1))}-${date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())}`; // 
				const endDate =
					`${date.getFullYear()}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : ('0' + (date.getMonth() + 1))}-${date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())}`;

				self.$get(
					`${baseUrl.online}/industria/priceIndex/list?groupCode=C8F123FC68DCFD08D853DF31E92A1069&beginDate=${beginDate}&endDate=${endDate}`, {}
				).then(res => {
					if (res.code == 0) {
						self.priceIndexJN = res.data[0];
						setTimeout(() => {
							self.swiperVerticalInit();
						}, 300)
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('获取指数错误')
				})
			},
			// 初始化竖向滚动
			swiperVerticalInit() {
				var swiper = new Swiper('.swiper-container-menu', {
					loop: true,
					autoplay: true,
					speed: 500,
					direction: 'vertical'
				});
			},


			/* ***** 二级菜单数据 end ******************************* */

			/* ***** 各个板块数据 start ***************************** */
			// 各个板块数据
			listInit() {
				$('.index-part-4 .el-carousel__arrow--right').attr('disabled', false);
				$('.index-part-4 .el-carousel__arrow--left').attr('disabled', true);
				this.searchFourReport();
				this.tNewsConsultSelFooter();
			},

			// 第二部分 右侧资讯信息

			// 第三部分，取报告分类下的最新一篇
			searchReport(id, name) {
				const self = this;
				self.$post(`${baseUrl.online}/industria/report/searchReport/1/1`, {
					reportSort: id
				}).then(res => {
					if (res.code == 0) {
						let obj = {
							name: name,
							data: res.data
						};
						if (name == '唐尔街日报') {
							self.searchReport_list[0] = obj;
						} else if (name == '监测预警周报') {
							self.searchReport_list[1] = obj;
						} else if (name == '唐宋100指数（周）报告') {
							self.searchReport_list[2] = obj;
						} else if (name == '唐宋100指数报告-分品种') {
							self.searchReport_list[3] = obj;
						}
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到快讯信息');
				})
			},

			// 第四部分 基准价地图
			findIndexTopList() {
				const self = this;
				self.$get(`${baseUrl.online}/industriaBasePrise/findIndexTopList`, {}).then(res => {
					if (res.code == 0) {
						let datas = $.extend(true, [], res.data);
						self.basePrice_list = datas //.splice(0, 6);
						// self.basePrice_list1 = res.data.splice(6, res.data.length - 6);
						self.basePriceTab = res.data[0].tag;
						self.basePriceTabItem = res.data[0];
						self.basePriceFindProducts(res.data[0]);
						setTimeout(() => {
							self.swiperInit2();
						}, 1000)
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到分类信息')
				})
			},
			// 渲染swiper
			swiperInit2() {
				var swiper = new Swiper('.swiper-container-2', {
					slidesPerView: 6,
					direction: 'horizontal',
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					}
				});
			},
			// 获取该分类下的产品
			basePriceFindProducts(param) {
				const self = this;
				self.$get(
					`${baseUrl.online}/industriaBasePrise/findProducts?tag=${param.tag}&type=${param.tag == 'MJ' ? param.type : ''}`, {}
				).then(res => {
					if (res.code == 0) {
						let _key, _val;
						res.data.forEach((item, index) => {
							if (item.val == '高线') {
								_key = item.key;
							}
							if (item.val == '热轧带钢') {
								_key = item.key;
							}
							if (item.val == '镀锌圆管') {
								_key = item.key;
							}
							if (item.val == '重型废钢') {
								_key = item.key;
							}
						})
						_key = _key ? _key : res.data[0].key;
						self.basePriceProduct_list = res.data;
						self.basePriceProduct_id = _key;
						self.findBasePriceData(param);
						self.findBasePriceRightList(param);
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到基准价产品信息')
				})
			},

			// 获取地图列表数据
			findBasePriceRightList(item) {
				const self = this;
				self.$get(
					`http://114.113.152.67:9090/basePriceRedis/findBasePriceRightList?tag=${item.tag}&productId=${self.basePriceProduct_id}&date=${item.dataDate}`, {}
				).then(res => {
					if (res.code == 0) {
						self.basePriceTable_list = res.data.splice(0, 16); //zhangziao
					} else {
						self.basePriceTable_list = [];
					}
				})
			},


			findBasePriceData(item) {
				const self = this;
				self.mapLoading = true;
				// ${baseUrl.online}/industriaBasePrise/findBasePriceMap
				// http://192.168.0.16/basePriceRedis/findBasePriceMap
				self.$get(
					`http://114.113.152.67:9090/basePriceRedis/findBasePriceMap?tag=${item.tag}&productId=${self.basePriceProduct_id}&date=${item.dataDate}`, {}
				).then(res => {
					if (res.code == 0) {
						res.data = res.data == null ? [] : res.data;
						let datas = $.extend(true, [], res.data);

						self.basePriceTable_title = item.basePriceName;
						let arr = [];
						let mapChart = self.$echarts.init(self.$refs.mapChart); //这里是为了获得容器所在位置    
						window.onresize = mapChart.resize;
						let option = new MapOption();
						option.series[0].name = `${item.basePriceName}`;
						option.title.text = `${item.basePriceName}` + '(' + res.data[0].dataDate + ')';
						datas.forEach((cItem, cIndex) => {
							if (cItem.areaName.indexOf('省') > 0) {
								const i = cItem.areaName.indexOf('省');
								cItem.areaName = cItem.areaName.substr(0, i);
							} else if (cItem.areaName.indexOf('内蒙古') > -1) {
								cItem.areaName = cItem.areaName.substr(0, 3);
							} else if (cItem.areaName.indexOf('天津') > -1 || cItem.areaName.indexOf('上海') >
								-1 || cItem.areaName.indexOf('重庆') > -1 || cItem.areaName.indexOf('北京') > -
								1 || cItem.areaName.indexOf('广西') > -1 || cItem.areaName.indexOf('新疆') > -
								1 || cItem.areaName.indexOf('宁夏') > -1 || cItem.areaName.indexOf('西藏') > -1
							) {
								cItem.areaName = cItem.areaName.substr(0, 2);
							}
							if (cItem.provinceTag == 'Y') {
								var hasArea = false;
								$.each(arr, (arrIndex, arrItem) => {
									if (arrItem.name == cItem.areaName) {
										hasArea = true;
									}
								})
								if (!hasArea) {
									arr.push({
										name: cItem.areaName,
										value: cItem.chg,
										price: cItem.price,
										chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) :
											0.00,
										originalName: cItem.originalName,
										date: cItem.dataDate
									})
								}
								// arr.push({
								//     name: cItem.areaName, 
								//     value: cItem.chg, 
								//     price: cItem.price, 
								//     chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00, 
								//     originalName: cItem.originalName, 
								//     date: cItem.dataDate
								// })
							}
							// arr.push({name: cItem.areaName, value: cItem.chg, price: cItem.price, chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00, originalName: cItem.originalName, date: cItem.dataDate})
						})
						option.series[0].data = arr;
						mapChart.setOption(option);
						self.mapLoading = false;
					} else {
						self.$message.error(res.message);
						self.mapLoading = false;
					}
				}).catch(err => {
					// self.$message.error('未获取到地图信息')
					self.mapLoading = false;
				})
			},
			changeMapClassify(tag) {
				this.basePriceProduct_id = tag;
				this.findBasePriceRightList(this.basePriceTabItem);
				this.findBasePriceData(this.basePriceTabItem);
			},

			// 第五部分 资讯推荐

			tNewsConsultSel(param) {
				const self = this;
				if (param) {
					$.ajax({
						url: `${baseUrl.service}/api_v3/news_classify_dict`,
						data: {
							type_name: param.type_name
						},
						dataType: 'json',
						type: 'get',
						success: (res) => {
							let classArr = [];
							res.data.forEach((item, index) => {
								if (item.the_level == 2) {
									classArr.push(item.type_name)
								}
							})
							self.tNewsConsultFuzzy(classArr)
						},
						error: () => {
							// self.$message.error('未获取到资讯信息')
						}
					})
				} else {
					self.tNewsConsultFuzzy()
				}

			},
			// 获取二级分类
			tNewsConsultFuzzy(arr) {
				const self = this;
				$.ajax({
					url: `${baseUrl.service}/api_v3/t_news_consult_fuzzy`,
					data: {
						type_name: arr ? arr.join(',') : '',
						pagenum: 1,
						pernum: 5
					},
					dataType: 'json',
					type: 'get',
					success: (res) => {
						self.inforTable_list2 = res.data;
					},
					error: () => {
						// self.$message.error('未获取到资讯信息')
					}
				})
			},

			// 最新研报推荐，取四条
			searchFourReport() {
				const self = this;
				self.$post(`${baseUrl.online}/industria/report/searchReport/1/5`, {}).then(res => {
					if (res.code == 0) {
						self.searchFourReport_list = res.data;
					} else {
						self.$message.error(res.message);
					}
				}).catch(err => {
					// self.$message.error('未获取到研报推荐信息');
				})
			},

			// 取底部资讯某一分类下的数据 暂取测试
			tNewsConsultSelFooter() {
				const self = this;
				$.ajax({
					url: `${baseUrl.service}/api_v3/t_news_consult_fuzzy?pagenum=1&pernum=99&type_name=唐宋动态`,
					data: {},
					dataType: 'json',
					type: 'get',
					success: (res) => {
						self.inforFooterTable_list = res.data;
						setTimeout(() => {
							self.swiperInit();
						}, 1000)
					},
					error: () => {
						// self.$message.error('未获取到资讯信息')
					}
				})
			},

			// 初始化唐宋动态swiper
			swiperInit() {
				var swiper = new Swiper('.swiper-container-1', {
					slidesPerView: 5,
					direction: 'horizontal',
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					}
				});
			},

			/* ***** 各个板块数据 end ***************************** */


			/* ****** 页面操作 start **************************************** */
			goInforDetailPage(param) { // 跳转到资讯详情页
				if (this.navigations_visit['资讯']) {
					this.$router.push(`/home/inforDetail/${param.primary_id}`)
				} else {
					this.$message({
						message: '登录即可查看全部资讯信息',
						type: 'warning'
					})
				}

			},
			goReportDetailPage(param) {
				if (this.navigations_visit['研报']) {
					this.$router.push(`/home/reportDetail/${param.reportId}`)
				} else {
					this.$message({
						message: '登录即可查看全部研报信息',
						type: 'warning'
					})
				}

			},
			goPriceIndex(name) {
				const url = this.navigations_list['指数']
				this.$router.push(url + '?location=' + name);
			},
			changeBasePrice(item) {
				this.basePriceTab = item.tag == 'MJ' ? (item.tag + '_' + item.type) : item.tag;
				this.basePriceTabItem = item;
				this.basePriceFindProducts(item);
			},
			inforTabChange(e) {
				if (e.index == 0) {
					this.tNewsConsultSel();
				} else {
					this.tNewsConsultSel(this.inforTab_list[e.index - 1]);
				}

			},
			goBasicPrice() {
				if (this.$cookies.get('token_cyw')) {
					this.$router.push(this.navigations_list['基准价']);
				} else {
					if (this.navigations_visit['基准价']) {
						let url = this.navigations_list['基准价'];
						url = url + '?tag=' + this.basePriceTab;
						this.$router.push(url);
					} else {
						this.$message({
							message: '登录即可查看全部基准价信息',
							type: 'warning'
						})
					}
				}
			},
			goSearchPage(name) {
				this.$router.push(`/home/searchPage?key=${name}&type=1`);
			},
			/* ****** 页面操作 end **************************************** */

			// 判断时间
			compareTime(date) {
				const time = new Date().getTime();
				const time_1 = new Date(date).getTime();
				const range = time - time_1;
				let time_2;
				let type = 'time';
				if (range <= 1800000) {
					time_2 = Math.floor(range / 60 / 1000);
					time_2 = time_2 < 0 ? '刚刚' : time_2 + '分钟前'
				} else if (range < 21600000 && range > 1800000) {
					if (range >= 3600000) {
						time_2 = Math.floor(range / 60 / 60 / 1000);
						time_2 += '小时前'
					} else {
						time_2 = Math.floor(range / 60 / 1000);
						time_2 += '分钟前'
					}
				} else if (range > 21600000) {
					const newDate = new Date(date);
					time_2 = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
					type = 'date'
				}
				return time_2
			},

			/*****************新增企业报价部分 start *********************/

			// 切换产品
			changeVarieties(type) {
				if (type != this.varietiesType) {
					this.varietiesType = type;
					// $('.index-quote-list-box').liMarquee('destroy');
					this.findOfferVarieties(type);
				}
			},

			// 获取全部产品
			findAllVarieties() {
				const self = this;
				self.$get(`${baseUrl.business}/api/varieties/findAll`, {}).then(res => {
					if (res.status == 200) {
						self.varietiesList = res.data;
						self.findOfferVarieties('');
					} else {
						self.$message.error(res.msg);
					}
				})
			},

			// 查询报价列表
			findOfferVarieties(id) {
				const self = this;
				const date = new Date();
				const _date =
					`${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)}-${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}`;
				const obj = {
					varietiesId: id,
					// attributeId: '',
					// marketKeys: '',
					status: true,
					// beginDate: _date,
					// endDate: _date,
					// searchKey: ''
				}

				self.varTableList = [];
				self.$post(`${baseUrl.business}/api/offer/searchAll/0/30`, obj).then(res => {
					if (res.status == 200) {
						if (res.data.content.length > 0) {
							let obj = {};
							res.data.content.forEach((item, index) => {
								const infos = item.enterpriseVarieties.attributeInfoFiledInfos;
								obj = {
									enterpriseName: item.enterpriseVarieties.enterpriseInfo.name,
									enterprisePhone: item.enterpriseVarieties.enterpriseInfo.phone,
									userPhone: item.enterpriseVarieties.user.userPhone,
									benchmarkStatus: item.enterpriseVarieties.enterpriseInfo
										.benchmarkStatus,
									recommendStatus: item.enterpriseVarieties.enterpriseInfo
										.recommendStatus,
									price: item.price,
									offerDate: item.offerDate,
									varietiesName: item.enterpriseVarieties.varieties.name,
									attribute0: infos && infos[0] ? infos[0].fieldInfo.fieldValue : '',
									attribute1: infos && infos[1] ? infos[1].fieldInfo.fieldValue : '',
									varietiesType: item.enterpriseVarieties.varieties.parent ? item
										.enterpriseVarieties.varieties.parent.id : item
										.enterpriseVarieties.varieties.id
								}
								self.varTableList.push(obj);
							})
							// console.log(self.varTableList)
							self.varIsNone = false;
							$('.index-quote-list-box').liMarquee('destroy');
							setTimeout(() => {
								self.marqueeInit(id);
							}, 500)
						} else {
							self.varIsNone = true;
						}
					}
				})
			},
			marqueeInit(id) {
				const self = this;
				$('.index-quote-list-box').liMarquee({
					direction: 'up',
					// loop: -1,
					scrollamount: 30,
					hoverstop: true
				});

			},
			// 跳转到企业报价详情页
			goQuoteDetail(phone) {
				this.$router.push(`/home/quoteDetail?id=${phone}`);
			},
			goQuote(_varietiesType) {
				this.$router.push(`/home/quote?type=${!_varietiesType ? '' : _varietiesType}`);
			},

			/*****************新增企业报价部分 end ***********************/

			/* 去下载页 */
			goDownLoadPage() {
				let routeData = this.$router.resolve({
					path: '/home/download'
				});
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	@import url('index.css');
	@import url('../../assets/css/liMarquee.css');

	.price-left /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #409EFF !important;
	}

	.price-left /deep/ tr {
		padding: 0;
		height: 36px !important;
	}

	.price-left /deep/ th {
		padding: 0;
		height: 36px !important;
	}

	.price-right /deep/ tr {
		padding: 0;
		height: 36px !important;
	}

	.price-right /deep/ th {
		padding: 0;
		height: 36px !important;
	}

	.price-title {
		font-size: 24px;
		font-weight: bold;
		position: absolute;
		top: 24px;
		display: block;
		left: 24px;
		right: 24px;
		padding-bottom: 12px;
		border-bottom: 2px solid #797979;
		color: #333;
	}

	.price-titlelist-parent {
		padding-bottom: 12px;
		border-bottom: 2px solid #797979;
	}

	.price-titlelist {
		font-size: 24px;
		font-weight: bold;
		position: absolute;
		top: 24px;
		display: inline-block;
		left: 24px;
		color: #797979;
	}

	.price-titlelist:hover {
		cursor: pointer;
	}

	.price-titlelist.l1 {
		left: 264px;
	}

	.price-titlelist.l2 {
		left: 550px;
	}

	.price-titlelist.active {
		color: #333333;
	}

	.price-left {
		display: inline-block;
		width: 740px;
		margin-top: 32px;
	}

	.price-right {
		display: inline-flex;
		flex-direction: column;
		align-items: flex-start;
		width: 460px;
		margin-top: 32px;
	}

	.table-title {
		font-size: 24px;
		margin-top: 9px;
		display: inline-block;
		color: #666666;
		font-weight: bold;
	}

	.prices {
		margin-top: 16px;
		display: flex;
		justify-content: space-between;
	}

	.prices .content {
		background-image: url('../../assets/images/price/waibiankuang.png');
		background-position: 2px 2px;
		background-size: 584px 132px;
	}

	.prices .item {
		width: 49%;
		position: relative;
	}

	.prices .item .title {
		position: relative;
		width: 150px;
		height: 40px;
		margin-left: 29px;
	}

	.prices .item.l .title::before {
		display: inline-block;
		position: absolute;
		left: -29px;
		top: 2px;
		width: 150px;
		height: 40px;
		content: "";
		background-image: url('../../assets/images/price/钢坯价格.png');
		background-size: 150px 40px;
	}

	.prices .item.r .title::before {
		display: inline-block;
		position: absolute;
		left: -29px;
		top: 2px;
		width: 150px;
		height: 40px;
		content: "";
		background-image: url('../../assets/images/price/带钢价格.png');
		background-size: 150px 40px;
	}

	.prices .item .label {
		display: inline-block;
		position: absolute;
		left: 128px;
		top: 6px;
		color: #FFFFFF;
		background: #FF8F16;
		width: 84px;
		height: 22px;
		line-height: 22px;
		text-align: center;
		font-size: 12px;
		border-radius: 4px;
	}

	.prices .item .label::before {
		content: "";
		display: inline-block;
		position: absolute;
		left: -12px;
		top: 5px;
		width: 0px;
		height: 0px;
		border: 6px solid #FF8F16;
		border-right-color: #FF8F16;
		border-bottom-color: transparent;
		border-left-color: transparent;
		border-top-color: transparent;
	}

	.prices .item .content {
		display: flex;
		justify-content: space-between;
		margin-bottom: 16px;
	}

	.prices .item .content .citem {
		width: 184px;
		height: 112px;
		border: 8px solid #C20001;
		margin-top: 4px;
		margin-left: -4px;
		margin-right: -4px;
		margin-bottom: 4px;
	}

	.prices .item .content .citem:first-child {
		width: 184px;
		height: 112px;
		border: 8px solid #C20001;
		margin-top: 4px;
		margin-left: 4px;
		margin-bottom: 4px;
	}

	.prices .item .content .citem:last-child {
		width: 184px;
		height: 112px;
		border: 8px solid #C20001;
		margin-top: 4px;
		margin-right: 4px;
		margin-bottom: 4px;
	}

	.prices .item .content .citem:hover {
		cursor: pointer;
	}

	.prices .item .content .citem .ctitle {
		background-color: #a30000;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		margin-top: 6px;
		margin-left: 6px;
		margin-right: 6px;
		letter-spacing: 2px;
		font-weight: bold;
		padding-top: 2px;
		padding-bottom: 2px;
	}

	.prices .item .content .citem .clook {
		color: #FFFFFF;
		background-color: #FEBF21;
		height: 24px;
		line-height: 24px;
		border-radius: 10px;
		font-size: 12px;
		text-align: center;
		width: 56px;
		float: right;
		margin-right: 24px;
		margin-top: 12px;
		padding-right: 8px;
		position: relative;
	}

	.prices .item .content .citem.up .clook {
		background-color: #D44735;
	}

	.prices .item .content .citem.down .clook {
		background-color: #2AD019;
	}

	.prices .item .content .citem .clook::before {
		content: "";
		display: inline-block;
		position: absolute;
		top: 8px;
		right: 8px;
		width: 6px;
		height: 6px;
		border-top: 2px solid #FFFFFF;
		border-right: 2px solid #FFFFFF;
		transform: rotate(45deg);
	}

	.prices .item .content .citem .cbottom {
		margin-top: 0px;
		margin-left: 8px;
		text-align: left;
		position: relative
	}

	.prices .item .content .citem .cbottom .cprice {
		position: relative;
		font-size: 40px;
		font-weight: bold;
		color: #333333;
	}

	.prices .item .content .citem .cbottom .btn {
		position: absolute;
		left: 146px;
		top: 25px;
		width: 24px;
		height: 24px;
	}

	.prices .item .content .citem .cbottom .arrow {
		position: relative;
		font-size: 16px;
		font-weight: bold;
		color: #FEBF21;
		margin-left: 6px;
	}

	.prices .item .content .citem .cbottom .cdate {
		font-size: 14px;
		color: #333333;
		margin-left: 6px;
	}

	.prices .item .content .citem.down .cbottom .arrow {
		color: #2AD019;
		margin-right: 4px;
	}

	.prices .item .content .citem.up .cbottom .arrow {
		color: #D44735;
		margin-right: 4px;
	}

	.prices .item .content .citem .cbottom img {
		position: absolute;
		width: 15px;
		height: 13px;
		left: -4px;
		top: 5px;
	}

	.index-quote {
		margin-top: 10px;
		box-sizing: border-box;
	}

	.quote-varieties-box {
		display: flex;
		border: 1px solid #C0C4CC;
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.quote-varieties-box>li {
		flex: 1;
		width: 100%
	}

	.quote-varieties-box>li>a {
		line-height: 40px;
		background: #DCDFE6;
		box-sizing: border-box;
	}

	.quote-varieties-box>li>a.active {
		background: #fff;
		color: #a30000 !important;
		border-right: 1px solid #c0c4cc;
	}

	.index-quote-list-box ul {
		line-height: 45px;
		border-bottom: 1px solid #ccc;
	}

	.index-quote-list-box .button {
		border: 1px solid #a30000;
		color: #a30000;
		padding: 0 4px;
		line-height: 24px;
	}

	.index-quote-list-box ul>li>span {
		vertical-align: middle;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.quote-enterprise-name {
		width: 72%;
	}

	.index-quote-list-box {
		height: 240px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.index-quote-list-box small {
		line-height: 18px;
		border: 1px solid #a30000;
		width: 18px;
		height: 18px;
		border-radius: 1px;
		font-size: 12px;
		margin-top: 0px;
		margin-left: 5px;
	}

	.fontRedLight {
		color: #F56C6C;
	}

	/* zhangziao */
	.jzj-bg-ground .bgGrey {
		border-top: solid 5px #a30000;
	}

	.custom-bg-r {
		background-color: #a30000 !important;
		color: #ffffff;
		font-weight: 700 !important;
	}

	@keyframes keyanim {
		from {
			transform: scale(1);
		}

		to {
			transform: scale(1.2);
		}
	}

	.anim {
		animation-name: keyanim;
		animation-duration: 2s;
	}
	
	.popup-ad-dialog-right {
		position: fixed;
		top: -56px;
		right: -36px;
		z-index: 999;
	}
	
	.popup-ad-dialog /deep/ .el-dialog {
		box-shadow: none;
		background-color: rgba(0, 0, 0, 0);
	}
	
	.popup-ad-dialog /deep/ .el-dialog__body {
		text-align: center;
	}
	
	.popup-ad-dialog /deep/ .el-dialog__headerbtn {
		position: ;
	}
	
	.popup-ad-dialog /deep/ .el-dialog__close {
		font-size: 40px;
		color: #FFFFFF;
		border: 2px solid #FFFFFF;
		border-radius: 100px;
	}
	
	.popup-ad-box {
		display: inline-block;
		position: relative;
		text-align: center;
		width: 480px;
		pointer-events: auto;
	}
	
	.popup-ad {
		width: 480px;
		height: 480px;
	}
	
	.popup-ad-day {
		position: absolute;
		width: 140px;
		height: 140px;
		left: 130px;
		top: 156px;
		z-index: 999;
	}
	
	.popup-ad-dialog-right {
		transition: all 0.32;
		pointer-events: none;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.popup-ad-dialog-right .popup-ad-box {
		transform: scale(0.4);
		transform-origin: 50% 50%;
		cursor: pointer;
	}
	
	.popup-ad-box iframe {
		width: 100%;
		height: 100%;
		border: none;
	}
	
	.popup-ad-dialog-right .popup-zp-box {
		transform: scale(0.4);
		transform-origin: 50% 0%;
		margin-top: -132px;
		margin-left: 8px;
		cursor: pointer;
		pointer-events: auto;
	}
	
	.popup-zp-box {
		width: calc(560px * 0.64);
		height: calc(720px * 0.60);
		display: inline-block;
		position: relative;
		text-align: center;
	}
	
	.popup-ad-dialog-right .popup-zp-box .popup-zp1 {
		position: absolute;
		width: calc(560px * 0.6);
		height: calc(560px * 0.6);
		top: 0%;
		left: calc(50% - 560px * 0.3);
		z-index: 2;
	}
	
	.popup-ad-dialog-right .popup-zp-box .popup-zp2 {
		position: absolute;
		width: calc(560px * 0.2);
		height: calc(560px * 0.22);
		top: calc(560px * 0.18);
		left: calc(50% - 560px * 0.1);
		z-index: 3;
	}
	
	.popup-ad-dialog-right .popup-zp-box .popup-zp3 {
		position: absolute;
		width: calc(560px * 0.64);
		height: calc(720px * 0.60);
		top: 0%;
		left: calc(50% - 560px * 0.32);
		z-index: 1;
	}
	
</style>
